{
  "defaultMessages.ACTIVE_DUTY": "현역군인",
  "defaultMessages.ARCHITECT": "건축사",
  "defaultMessages.CHILD_CARE_WORKER": "보육사",
  "defaultMessages.COMMUNITY_ELIGIBILITY_PROVISION": "CEP(커뮤니티 자격 조항, 타이틀 1/LAP)",
  "defaultMessages.DENTIST": "치과 의사",
  "defaultMessages.DOCTOR": "의사",
  "defaultMessages.EMT": "응급구조사",
  "defaultMessages.FIREFIGHTER": "소방관",
  "defaultMessages.GENERAL_CONTRACTOR": "종합건설업자",
  "defaultMessages.GOLD_STAR_FAMILY": "골드스타 가족",
  "defaultMessages.HOME_BUYER": "주택 구매자",
  "defaultMessages.INTERIOR_DESIGNER": "인테리어 디자이너",
  "defaultMessages.LIBRARIAN": "사서",
  "defaultMessages.LICENSED_COSMETOLOGIST": "면허 미용사",
  "defaultMessages.LICENSED_REAL_ESTATE_AGENT": "공인 부동산 중개사",
  "defaultMessages.MILITARY_FAMILY": "군인 가족",
  "defaultMessages.MILITARY_RETIREE": "군 퇴역자",
  "defaultMessages.NURSE": "간호사",
  "defaultMessages.NUTRITION_PROFESSIONAL": "영양 전문가",
  "defaultMessages.OTHER_GOVERNMENT_ASSISTANCE": "기타 정부 지원 수혜자",
  "defaultMessages.OTHER_HEALTH_WORKER": "기타 의료 종사자",
  "defaultMessages.OTHER_MOVER": "기타 이사업자",
  "defaultMessages.PHARMACIST": "약사",
  "defaultMessages.POLICE": "경찰관",
  "defaultMessages.RESERVIST": "예비군 또는 주 방위군",
  "defaultMessages.SEARCH_AND_RESCUE": "수색 구조대원",
  "defaultMessages.SNAP_BENEFITS": "SNAP 혜택 수혜자",
  "defaultMessages.VETERAN": "군 제대자 또는 퇴역자",
  "defaultMessages.VETERINARIAN": "수의사",
  "defaultMessages._EXPERIMENTAL.cvecNumberExplanation": "CVEC 번호를 추가하면 즉시 인증될 가능성이 높아집니다.",
  "defaultMessages.activeDutyStartDate": "현역 시작일",
  "defaultMessages.address": "주소",
  "defaultMessages.addressPlaceholder": "주소",
  "defaultMessages.birthDate": "생년월일",
  "defaultMessages.branchOfService": "복무 군종",
  "defaultMessages.branchOfServicePlaceholder": "복무 군종",
  "defaultMessages.cantFindYourSchool": "학교를 찾을 수 없으십니까? 도움말을 보려면 클릭하세요",
  "defaultMessages.captchaFooterText": "Cloudflare는 사기 방지 목적의 본인 확인과 관련하여 귀하의 정보를 독립적으로 수집하며, 이를 자사의 <cloudflarePrivacyPolicy>개인정보 처리방침</cloudflarePrivacyPolicy>에 따라 사용합니다.",
  "defaultMessages.changeLanguage": "언어 변경",
  "defaultMessages.chooseCountry": "검색하기 전에 국가를 선택하십시오",
  "defaultMessages.city": "시/군/구",
  "defaultMessages.cityPlaceholder": "시/군/구",
  "defaultMessages.clearAndOpenMenu": "선택 초기화 및 메뉴 열기",
  "defaultMessages.clearSelection": "선택 초기화",
  "defaultMessages.close": "닫기",
  "defaultMessages.closeSection": "섹션 닫기",
  "defaultMessages.company": "회사명",
  "defaultMessages.companyPlaceholder": "회사명",
  "defaultMessages.copied": "복사됨",
  "defaultMessages.countries.AD": "안도라",
  "defaultMessages.countries.AE": "아랍에미리트",
  "defaultMessages.countries.AF": "아프가니스탄",
  "defaultMessages.countries.AG": "앤티가 바부다",
  "defaultMessages.countries.AI": "앵귈라",
  "defaultMessages.countries.AL": "알바니아",
  "defaultMessages.countries.AM": "아르메니아",
  "defaultMessages.countries.AN": "네덜란드령 앤틸리스",
  "defaultMessages.countries.AO": "앙골라",
  "defaultMessages.countries.AR": "아르헨티나",
  "defaultMessages.countries.AS": "미국령 사모아",
  "defaultMessages.countries.AT": "오스트리아",
  "defaultMessages.countries.AU": "오스트레일리아",
  "defaultMessages.countries.AW": "아루바",
  "defaultMessages.countries.AZ": "아제르바이잔",
  "defaultMessages.countries.BA": "보스니아 헤르체고비나",
  "defaultMessages.countries.BB": "바베이도스",
  "defaultMessages.countries.BD": "방글라데시",
  "defaultMessages.countries.BE": "벨기에",
  "defaultMessages.countries.BF": "부르키나파소",
  "defaultMessages.countries.BG": "불가리아",
  "defaultMessages.countries.BH": "바레인",
  "defaultMessages.countries.BI": "부룬디",
  "defaultMessages.countries.BJ": "베냉",
  "defaultMessages.countries.BM": "버뮤다",
  "defaultMessages.countries.BN": "브루나이",
  "defaultMessages.countries.BO": "볼리비아",
  "defaultMessages.countries.BR": "브라질",
  "defaultMessages.countries.BS": "바하마",
  "defaultMessages.countries.BT": "부탄",
  "defaultMessages.countries.BV": "부베 섬",
  "defaultMessages.countries.BW": "보츠와나",
  "defaultMessages.countries.BY": "벨라루스",
  "defaultMessages.countries.BZ": "벨리즈",
  "defaultMessages.countries.CA": "캐나다",
  "defaultMessages.countries.CD": "콩고 민주 공화국",
  "defaultMessages.countries.CF": "중앙아프리카 공화국",
  "defaultMessages.countries.CG": "콩고 공화국",
  "defaultMessages.countries.CH": "스위스",
  "defaultMessages.countries.CI": "코트디부아르",
  "defaultMessages.countries.CK": "쿡 제도",
  "defaultMessages.countries.CL": "칠레",
  "defaultMessages.countries.CM": "카메룬",
  "defaultMessages.countries.CN": "중국",
  "defaultMessages.countries.CO": "콜롬비아",
  "defaultMessages.countries.CR": "코스타리카",
  "defaultMessages.countries.CU": "쿠바",
  "defaultMessages.countries.CV": "카보베르데",
  "defaultMessages.countries.CW": "퀴라소",
  "defaultMessages.countries.CY": "키프로스",
  "defaultMessages.countries.CZ": "체코 공화국",
  "defaultMessages.countries.DE": "독일",
  "defaultMessages.countries.DJ": "지부티",
  "defaultMessages.countries.DK": "덴마크",
  "defaultMessages.countries.DM": "도미니카",
  "defaultMessages.countries.DO": "도미니카 공화국",
  "defaultMessages.countries.DZ": "알제리",
  "defaultMessages.countries.EC": "에콰도르",
  "defaultMessages.countries.EE": "에스토니아",
  "defaultMessages.countries.EG": "이집트",
  "defaultMessages.countries.EH": "서사하라",
  "defaultMessages.countries.ER": "에리트레아",
  "defaultMessages.countries.ES": "스페인",
  "defaultMessages.countries.ET": "에티오피아",
  "defaultMessages.countries.FI": "핀란드",
  "defaultMessages.countries.FJ": "피지",
  "defaultMessages.countries.FK": "포클랜드 제도",
  "defaultMessages.countries.FM": "미크로네시아",
  "defaultMessages.countries.FO": "페로 제도",
  "defaultMessages.countries.FR": "프랑스",
  "defaultMessages.countries.GA": "가봉",
  "defaultMessages.countries.GB": "영국",
  "defaultMessages.countries.GD": "그레나다",
  "defaultMessages.countries.GE": "조지아",
  "defaultMessages.countries.GF": "프랑스령 기아나",
  "defaultMessages.countries.GH": "가나",
  "defaultMessages.countries.GI": "지브롤터",
  "defaultMessages.countries.GL": "그린란드",
  "defaultMessages.countries.GM": "감비아",
  "defaultMessages.countries.GN": "기니",
  "defaultMessages.countries.GP": "과들루프(프랑스령)",
  "defaultMessages.countries.GQ": "적도 기니",
  "defaultMessages.countries.GR": "그리스",
  "defaultMessages.countries.GS": "사우스조지아 사우스샌드위치 제도",
  "defaultMessages.countries.GT": "과테말라",
  "defaultMessages.countries.GU": "괌(미국)",
  "defaultMessages.countries.GW": "기니비사우",
  "defaultMessages.countries.GY": "가이아나",
  "defaultMessages.countries.HK": "홍콩",
  "defaultMessages.countries.HM": "허드 맥도널드 제도",
  "defaultMessages.countries.HN": "온두라스",
  "defaultMessages.countries.HR": "크로아티아",
  "defaultMessages.countries.HT": "아이티",
  "defaultMessages.countries.HU": "헝가리",
  "defaultMessages.countries.ID": "인도네시아",
  "defaultMessages.countries.IE": "아일랜드",
  "defaultMessages.countries.IL": "이스라엘",
  "defaultMessages.countries.IN": "인도",
  "defaultMessages.countries.IO": "영국령 인도양 지역",
  "defaultMessages.countries.IQ": "이라크",
  "defaultMessages.countries.IR": "이란",
  "defaultMessages.countries.IS": "아이슬란드",
  "defaultMessages.countries.IT": "이탈리아",
  "defaultMessages.countries.JM": "자메이카",
  "defaultMessages.countries.JO": "요르단",
  "defaultMessages.countries.JP": "일본",
  "defaultMessages.countries.KE": "케냐",
  "defaultMessages.countries.KG": "키르기스스탄",
  "defaultMessages.countries.KH": "캄보디아",
  "defaultMessages.countries.KI": "키리바시",
  "defaultMessages.countries.KM": "코모로",
  "defaultMessages.countries.KN": "세인트키츠 네비스",
  "defaultMessages.countries.KP": "북한",
  "defaultMessages.countries.KR": "대한민국",
  "defaultMessages.countries.KW": "쿠웨이트",
  "defaultMessages.countries.KY": "케이맨 제도",
  "defaultMessages.countries.KZ": "카자흐스탄",
  "defaultMessages.countries.LA": "라오스",
  "defaultMessages.countries.LB": "레바논",
  "defaultMessages.countries.LC": "세인트루시아",
  "defaultMessages.countries.LI": "리히텐슈타인",
  "defaultMessages.countries.LK": "스리랑카",
  "defaultMessages.countries.LR": "라이베리아",
  "defaultMessages.countries.LS": "레소토",
  "defaultMessages.countries.LT": "리투아니아",
  "defaultMessages.countries.LU": "룩셈부르크",
  "defaultMessages.countries.LV": "라트비아",
  "defaultMessages.countries.LY": "리비아",
  "defaultMessages.countries.MA": "모로코",
  "defaultMessages.countries.MC": "모나코",
  "defaultMessages.countries.MD": "몰도바",
  "defaultMessages.countries.ME": "몬테네그로",
  "defaultMessages.countries.MG": "마다가스카르",
  "defaultMessages.countries.MH": "마셜 제도",
  "defaultMessages.countries.MK": "마케도니아",
  "defaultMessages.countries.ML": "말리",
  "defaultMessages.countries.MM": "미얀마",
  "defaultMessages.countries.MN": "몽골",
  "defaultMessages.countries.MO": "마카오",
  "defaultMessages.countries.MP": "북마리아나 제도",
  "defaultMessages.countries.MQ": "마르티니크(프랑스령)",
  "defaultMessages.countries.MR": "모리타니",
  "defaultMessages.countries.MS": "몬트세랫",
  "defaultMessages.countries.MT": "몰타",
  "defaultMessages.countries.MU": "모리셔스",
  "defaultMessages.countries.MV": "몰디브",
  "defaultMessages.countries.MW": "말라위",
  "defaultMessages.countries.MX": "멕시코",
  "defaultMessages.countries.MY": "말레이시아",
  "defaultMessages.countries.MZ": "모잠비크",
  "defaultMessages.countries.NA": "나미비아",
  "defaultMessages.countries.NC": "뉴칼레도니아(프랑스령)",
  "defaultMessages.countries.NE": "니제르",
  "defaultMessages.countries.NF": "노퍽 섬",
  "defaultMessages.countries.NG": "나이지리아",
  "defaultMessages.countries.NI": "니카라과",
  "defaultMessages.countries.NL": "네덜란드",
  "defaultMessages.countries.NO": "노르웨이",
  "defaultMessages.countries.NP": "네팔",
  "defaultMessages.countries.NR": "나우루",
  "defaultMessages.countries.NU": "니우에",
  "defaultMessages.countries.NZ": "뉴질랜드",
  "defaultMessages.countries.OM": "오만",
  "defaultMessages.countries.PA": "파나마",
  "defaultMessages.countries.PE": "페루",
  "defaultMessages.countries.PF": "프랑스령 폴리네시아",
  "defaultMessages.countries.PG": "파푸아뉴기니",
  "defaultMessages.countries.PH": "필리핀",
  "defaultMessages.countries.PK": "파키스탄",
  "defaultMessages.countries.PL": "폴란드",
  "defaultMessages.countries.PM": "생피에르 미클롱",
  "defaultMessages.countries.PN": "핏케언 섬",
  "defaultMessages.countries.PR": "푸에르토리코",
  "defaultMessages.countries.PS": "팔레스타인",
  "defaultMessages.countries.PT": "포르투갈",
  "defaultMessages.countries.PW": "팔라우",
  "defaultMessages.countries.PY": "파라과이",
  "defaultMessages.countries.QA": "카타르",
  "defaultMessages.countries.RE": "레위니옹(프랑스령)",
  "defaultMessages.countries.RO": "루마니아",
  "defaultMessages.countries.RS": "세르비아",
  "defaultMessages.countries.RU": "러시아 연방",
  "defaultMessages.countries.RW": "르완다",
  "defaultMessages.countries.SA": "사우디아라비아",
  "defaultMessages.countries.SB": "솔로몬 제도",
  "defaultMessages.countries.SC": "세이셸",
  "defaultMessages.countries.SD": "수단",
  "defaultMessages.countries.SE": "스웨덴",
  "defaultMessages.countries.SG": "싱가포르",
  "defaultMessages.countries.SH": "세인트헬레나",
  "defaultMessages.countries.SI": "슬로베니아",
  "defaultMessages.countries.SK": "슬로바키아 공화국",
  "defaultMessages.countries.SL": "시에라리온",
  "defaultMessages.countries.SM": "산마리노",
  "defaultMessages.countries.SN": "세네갈",
  "defaultMessages.countries.SO": "소말리아",
  "defaultMessages.countries.SR": "수리남",
  "defaultMessages.countries.SS": "남수단",
  "defaultMessages.countries.ST": "상투메 프린시페",
  "defaultMessages.countries.SV": "엘살바도르",
  "defaultMessages.countries.SY": "시리아",
  "defaultMessages.countries.SZ": "스와질란드",
  "defaultMessages.countries.TC": "터크스 케이커스 제도",
  "defaultMessages.countries.TD": "차드",
  "defaultMessages.countries.TF": "프랑스령 남방 지역",
  "defaultMessages.countries.TG": "토고",
  "defaultMessages.countries.TH": "태국",
  "defaultMessages.countries.TJ": "타지키스탄",
  "defaultMessages.countries.TK": "토켈라우",
  "defaultMessages.countries.TL": "동티모르",
  "defaultMessages.countries.TM": "투르크메니스탄",
  "defaultMessages.countries.TN": "튀니지",
  "defaultMessages.countries.TO": "통가",
  "defaultMessages.countries.TR": "터키",
  "defaultMessages.countries.TT": "트리니다드 토바고",
  "defaultMessages.countries.TV": "투발루",
  "defaultMessages.countries.TW": "대만",
  "defaultMessages.countries.TZ": "탄자니아",
  "defaultMessages.countries.UA": "우크라이나",
  "defaultMessages.countries.UG": "우간다",
  "defaultMessages.countries.UM": "미국령 군소 제도",
  "defaultMessages.countries.US": "미국",
  "defaultMessages.countries.UY": "우루과이",
  "defaultMessages.countries.UZ": "우즈베키스탄",
  "defaultMessages.countries.VA": "바티칸 시국",
  "defaultMessages.countries.VC": "세인트빈센트 그레나딘",
  "defaultMessages.countries.VE": "베네수엘라",
  "defaultMessages.countries.VG": "영국령 버진아일랜드",
  "defaultMessages.countries.VI": "미국령 버진아일랜드",
  "defaultMessages.countries.VN": "베트남",
  "defaultMessages.countries.VU": "바누아투",
  "defaultMessages.countries.WF": "왈리스 푸투나 제도",
  "defaultMessages.countries.WS": "사모아",
  "defaultMessages.countries.XK": "코소보",
  "defaultMessages.countries.YE": "예멘",
  "defaultMessages.countries.YT": "마요트",
  "defaultMessages.countries.ZA": "남아프리카 공화국",
  "defaultMessages.countries.ZM": "잠비아",
  "defaultMessages.countries.ZW": "짐바브웨",
  "defaultMessages.country": "국가",
  "defaultMessages.countryPlaceholder": "국가",
  "defaultMessages.cvecNumber": "CVEC 인증서 번호",
  "defaultMessages.cvecNumberExplanation": "선택 사항 - CVEC 번호를 입력하시면 즉시 인증될 가능성이 높아집니다.",
  "defaultMessages.dateTime.20_MIN": "20분",
  "defaultMessages.dateTime.24_HRS": "24시간",
  "defaultMessages.dateTime.2_DAY": "2일",
  "defaultMessages.dateTime.2_HRS": "2시간",
  "defaultMessages.dateTime.2_MIN": "2분",
  "defaultMessages.dateTime.3_DAY": "3일",
  "defaultMessages.dateTime.A_FEW_DAYS": "며칠",
  "defaultMessages.dateTime.A_FEW_HOURS": "몇 시간",
  "defaultMessages.dateTime.A_FEW_MINUTES": "몇 분",
  "defaultMessages.dateTime.A_HALF_HOUR": "30분",
  "defaultMessages.dateTime.april": "4월",
  "defaultMessages.dateTime.august": "8월",
  "defaultMessages.dateTime.day": "일",
  "defaultMessages.dateTime.december": "12월",
  "defaultMessages.dateTime.february": "2월",
  "defaultMessages.dateTime.january": "1월",
  "defaultMessages.dateTime.july": "7월",
  "defaultMessages.dateTime.june": "6월",
  "defaultMessages.dateTime.march": "3월",
  "defaultMessages.dateTime.may": "5월",
  "defaultMessages.dateTime.month": "월",
  "defaultMessages.dateTime.november": "11월",
  "defaultMessages.dateTime.october": "10월",
  "defaultMessages.dateTime.september": "9월",
  "defaultMessages.dateTime.year": "년",
  "defaultMessages.dischargeDate": "전역일",
  "defaultMessages.driverLicenseNumber": "운전면허 번호",
  "defaultMessages.driverLicenseNumberPlaceholder": "운전면허 번호",
  "defaultMessages.driverLicenseState": "운전면허 발급 주",
  "defaultMessages.ebtCardNumber": "EBT 카드 번호",
  "defaultMessages.emailAddress": "이메일 주소",
  "defaultMessages.emailAddressPlaceholder": "이메일 주소",
  "defaultMessages.error": "오류",
  "defaultMessages.errorDetailId.govIdMismatch": "입력하신 정보와 신분증이 일치하지 않습니다. 다시 시도해 주십시오.",
  "defaultMessages.errorDetailId.govIdOtherFailure": "신분증 확인 중 문제가 발생했습니다. <feedbackFormLink>SheerID 지원팀에 문의해 주십시오</feedbackFormLink>.",
  "defaultMessages.errorDetailId.govIdRetakeBiometric": "모션 캡처 확인 중 문제가 발생했습니다. 다시 시도해 주십시오: <selfieTipsLink/>.",
  "defaultMessages.errorDetailId.govIdRetakeId": "정부 발급 신분증 확인 중 문제가 발생했습니다. 다시 시도해 주십시오: <imageTipsLink/>.",
  "defaultMessages.errorDetailId.govIdUnsupportedDoc": "지원되지 않는 문서입니다. 지원되는 정부 발급 신분증으로 다시 시도해 주십시오.",
  "defaultMessages.errorDetailId.personLimit": "이미 이 혜택이 승인된 것으로 보입니다.",
  "defaultMessages.errorDetailId.troubleVerifying": "현재 본인 확인에 어려움이 있는 것으로 보입니다. <feedbackFormLink>SheerID 지원팀에 문의해 주십시오</feedbackFormLink>.",
  "defaultMessages.errorDetailId.unableToVerify": "현재 본인 확인이 불가능합니다. 오류라고 생각되시면 <feedbackFormLink>SheerID 지원팀에 문의해 주십시오</feedbackFormLink>.",
  "defaultMessages.errorDetailId.vpnsNotAllowed": "이 프로그램에서는 VPN을 허용하지 않습니다. VPN을 해제하고 다시 시도해 주십시오. 오류라고 생각되시면 <feedbackFormLink>SheerID 지원팀에 문의해 주십시오</feedbackFormLink>.",
  "defaultMessages.errorId.activeDutyStartDateBeforeBirthDate": "시작일은 생년월일 이후여야 합니다",
  "defaultMessages.errorId.apiRateLimitExceeded": "현재 요청을 처리할 수 없습니다. 잠시 후 다시 시도해 주십시오",
  "defaultMessages.errorId.dischargeDateBeforeBirthDate": "전역일이 생년월일보다 이전입니다",
  "defaultMessages.errorId.docReviewLimitExceeded": "문서 검토 한도를 초과했습니다",
  "defaultMessages.errorId.duplicateFile": "일부 파일이 동일한 것으로 보입니다. 다른 파일을 선택해 주십시오.",
  "defaultMessages.errorId.expiredEmailLoopToken": "요청하신 페이지를 찾을 수 없습니다. URL이 올바르지 않거나 페이지가 더 이상 제공되지 않을 수 있습니다.",
  "defaultMessages.errorId.expiredProgram": "수요가 매우 높아 혜택이 더 이상 제공되지 않습니다. 내일 다시 확인해 주십시오.",
  "defaultMessages.errorId.expiredSMSCode": "인증 코드가 만료되었습니다",
  "defaultMessages.errorId.expiredVerification": "이 인증은 만료되었습니다. 새로운 인증을 제출해 주십시오.",
  "defaultMessages.errorId.failedToFetch": "HTTP 요청에 실패했습니다",
  "defaultMessages.errorId.fraudRulesReject": "제출된 정보로는 본인 확인이 불가능합니다. 정보의 정확성을 확인하시고 본인의 모바일 기기 또는 컴퓨터만 사용해 주십시오.<br></br>여전히 문제가 있으신가요? <feedbackFormLink>SheerID 지원팀에 문의</feedbackFormLink>하여 신원을 확인해 주십시오.",
  "defaultMessages.errorId.futureActiveDutyStartDate": "미래 시작일",
  "defaultMessages.errorId.futureBirthDate": "미래 생년월일",
  "defaultMessages.errorId.futureDischargeDate": "미래 전역일",
  "defaultMessages.errorId.inactiveProgram": "수요가 매우 높아 혜택이 더 이상 제공되지 않습니다. 내일 다시 확인해 주십시오.",
  "defaultMessages.errorId.incorrectVerificationOverrideCodeAttemptLimitExceeded": "오버라이드 코드 한도를 초과했습니다",
  "defaultMessages.errorId.ineligibleOrganization": "선택하신 기관은 이 혜택의 기준을 충족하지 않습니다.",
  "defaultMessages.errorId.internalServerError": "내부 서버 오류",
  "defaultMessages.errorId.invalidActiveDutyStartDate": "유효하지 않은 시작일",
  "defaultMessages.errorId.invalidAddress": "유효하지 않은 주소",
  "defaultMessages.errorId.invalidApiToken": "제공된 API 토큰이 유효하지 않거나 비어 있습니다",
  "defaultMessages.errorId.invalidAuthenticationLoopToken": "제공된 코드가 유효하지 않습니다",
  "defaultMessages.errorId.invalidBirthDate": "유효하지 않은 생년월일",
  "defaultMessages.errorId.invalidCaptchaToken": "캡차 인증에 실패했습니다.",
  "defaultMessages.errorId.invalidCity": "유효하지 않은 도시",
  "defaultMessages.errorId.invalidCountry": "유효하지 않은 국가",
  "defaultMessages.errorId.invalidCvecNumber": "유효하지 않은 CVEC 인증서 번호",
  "defaultMessages.errorId.invalidDischargeDate": "유효하지 않은 전역일",
  "defaultMessages.errorId.invalidDocUploadToken": "제공된 문서 업로드 토큰이 유효하지 않습니다",
  "defaultMessages.errorId.invalidDriverLicenseNumber": "유효하지 않은 운전면허 번호",
  "defaultMessages.errorId.invalidEbtCardNumber": "유효하지 않은 EBT 카드 번호",
  "defaultMessages.errorId.invalidEmail": "유효하지 않은 이메일",
  "defaultMessages.errorId.invalidEmailLoopToken": "요청하신 페이지를 찾을 수 없습니다. URL이 올바르지 않거나 페이지가 더 이상 제공되지 않을 수 있습니다.",
  "defaultMessages.errorId.invalidFileSizeEmpty": "하나 이상의 파일이 비어 있습니다",
  "defaultMessages.errorId.invalidFileSizeMax": "하나 이상의 파일이 너무 큽니다 (최대: 10MB)",
  "defaultMessages.errorId.invalidFirstName": "유효하지 않은 이름",
  "defaultMessages.errorId.invalidFirstResponderStatus": "유효하지 않은 응급 구조대원 상태",
  "defaultMessages.errorId.invalidLastName": "유효하지 않은 성",
  "defaultMessages.errorId.invalidMemberId": "유효하지 않은 ID 번호",
  "defaultMessages.errorId.invalidMilitaryStatus": "유효하지 않은 군인 신분",
  "defaultMessages.errorId.invalidNumberOfFiles": "최대 파일 수를 초과했습니다 (최대: 5개)",
  "defaultMessages.errorId.invalidOptIn": "계속하려면 선택해야 합니다",
  "defaultMessages.errorId.invalidOrganization": "목록에서 기관을 선택해야 합니다",
  "defaultMessages.errorId.invalidOverrideCode": "유효하지 않은 오버라이드 코드",
  "defaultMessages.errorId.invalidPhoneNumber": "유효하지 않은 휴대전화 번호",
  "defaultMessages.errorId.invalidPostalCode": "유효하지 않은 우편번호",
  "defaultMessages.errorId.invalidProgram": "유효하지 않은 프로그램",
  "defaultMessages.errorId.invalidRequest": "유효하지 않은 요청",
  "defaultMessages.errorId.invalidSMSCode": "인증 코드를 확인할 수 없습니다",
  "defaultMessages.errorId.invalidSocialSecurityNumber": "유효하지 않은 사회보장번호",
  "defaultMessages.errorId.invalidState": "유효하지 않은 주",
  "defaultMessages.errorId.invalidStatus": "유효하지 않은 상태",
  "defaultMessages.errorId.invalidStatuses": "유효하지 않은 상태",
  "defaultMessages.errorId.invalidStep": "유효하지 않은 단계",
  "defaultMessages.errorId.marketConsentRequired": "시장 동의가 필요합니다",
  "defaultMessages.errorId.maxMetadataLengthExceeded": "메타데이터 값의 최대 길이를 초과했습니다",
  "defaultMessages.errorId.maxMetadataValuesExceeded": "메타데이터 값의 최대 수를 초과했습니다",
  "defaultMessages.errorId.missingRequiredExternalId": "인증을 위해 로그인이 필요합니다. 계정에 로그인한 후 다시 시도해 주십시오.",
  "defaultMessages.errorId.missingRequiredMetadata": "인증을 위해 로그인이 필요합니다. 계정에 로그인한 후 다시 시도해 주십시오.",
  "defaultMessages.errorId.noProgram": "프로그램을 찾을 수 없습니다",
  "defaultMessages.errorId.noRemainingRewardCodes": "수요가 매우 높아 혜택이 더 이상 제공되지 않습니다. 내일 다시 확인해 주십시오.",
  "defaultMessages.errorId.noValidFiles": "유효한 파일이 없습니다",
  "defaultMessages.errorId.noVerification": "인증을 찾을 수 없습니다",
  "defaultMessages.errorId.notApproved": "승인되지 않았습니다",
  "defaultMessages.errorId.notFound": "찾을 수 없습니다",
  "defaultMessages.errorId.outsideAgePerson": "생년월일이 이 혜택의 적용 대상이 아닙니다.",
  "defaultMessages.errorId.requestTimeout": "요청 시간이 초과되었습니다",
  "defaultMessages.errorId.simulatedError": "시뮬레이션된 오류입니다",
  "defaultMessages.errorId.unauthorizedAccountStatus": "이 혜택은 일시적으로 중단되었습니다. 자세한 내용은 브랜드 고객 지원팀에 문의해 주십시오.",
  "defaultMessages.errorId.unauthorizedDomain": "허가되지 않은 도메인",
  "defaultMessages.errorId.underagePerson": "16세 미만은 이 혜택을 이용하실 수 없습니다.",
  "defaultMessages.errorId.unknownError": "알 수 없는 오류",
  "defaultMessages.errorId.unsupportedDocMimeType": "하나 이상의 파일이 지원되지 않는 형식입니다",
  "defaultMessages.errorId.verificationLimitExceeded": "열의에 감사드립니다. 그러나 이미 이 혜택을 이용하셨거나 이용을 시도하신 것으로 보입니다.",
  "defaultMessages.experiment.step.docUpload.documentConsiderations": "문서 관련 고려 사항",
  "defaultMessages.firstName": "이름",
  "defaultMessages.firstNamePlaceholder": "이름",
  "defaultMessages.firstResponderInfoShared": "여기에 입력된 정보는 인증 목적으로 사용됩니다.",
  "defaultMessages.footerText": "위의 개인 정보를 제출함으로써, 본인은 할인을 신청하는 사업체의 <privacyPolicy>개인정보 처리방침</privacyPolicy>에 따라 개인 정보가 수집됨을 인정하며, SheerID가 특별 혜택에 대한 자격을 확인하기 위해 프로세서/제3자 서비스 제공자로서 개인 정보를 SheerID와 공유한다는 것을 이해합니다. <aboutSheerID>SheerID에 대해 자세히 알아보세요.</aboutSheerID>",
  "defaultMessages.getHelp": "도움 받기",
  "defaultMessages.howDoesReviewWork": "심사는 어떻게 진행됩니까?",
  "defaultMessages.howDoesVerifyingWork": "인증은 어떻게 진행됩니까?",
  "defaultMessages.infoShared1": "클릭함으로써, 본인은 {privacyPolicyLink}에 설명된 바와 같이 자격 확인 목적으로 정보 처리에 동의합니다",
  "defaultMessages.infoShared2": ". 본인의 정보가 {companyName}와 공유된다는 것을 이해합니다.",
  "defaultMessages.informationTransferredToUS": "귀하의 정보는 미국으로 전송되며 SheerID의 개인정보 처리방침에 따라 처리됩니다.",
  "defaultMessages.instant": "즉시",
  "defaultMessages.lastName": "성",
  "defaultMessages.lastNamePlaceholder": "성",
  "defaultMessages.limitExceededError": "인증 한도 초과",
  "defaultMessages.loading": "로딩 중...",
  "defaultMessages.locales.ar": "العربية",
  "defaultMessages.locales.bg": "български",
  "defaultMessages.locales.bn-IN": "বাংলা (ভারত)",
  "defaultMessages.locales.cs": "čeština",
  "defaultMessages.locales.da": "Dansk",
  "defaultMessages.locales.de": "Deutsch",
  "defaultMessages.locales.el": "Ελληνικά",
  "defaultMessages.locales.en-GB": "English (UK)",
  "defaultMessages.locales.en-US": "English",
  "defaultMessages.locales.es": "Español",
  "defaultMessages.locales.es-ES": "Español (España)",
  "defaultMessages.locales.fi": "suomi",
  "defaultMessages.locales.fr": "Français",
  "defaultMessages.locales.fr-CA": "Français (Canada)",
  "defaultMessages.locales.ga": "Gaeilge",
  "defaultMessages.locales.hi-IN": "हिंदी (भारत)",
  "defaultMessages.locales.hr": "hrvatski",
  "defaultMessages.locales.hu": "magyar",
  "defaultMessages.locales.id": "Bahasa Indonesia",
  "defaultMessages.locales.is": "Íslenska",
  "defaultMessages.locales.it": "Italiano",
  "defaultMessages.locales.iw": "עברית",
  "defaultMessages.locales.ja": "日本語",
  "defaultMessages.locales.ko": "한국어",
  "defaultMessages.locales.lo": "ລາວ",
  "defaultMessages.locales.lt": "Lietuvių",
  "defaultMessages.locales.ms": "Bahasa Melayu",
  "defaultMessages.locales.nl": "Nederlands",
  "defaultMessages.locales.nl-BE": "Vlaams",
  "defaultMessages.locales.no": "Norsk",
  "defaultMessages.locales.pl": "Polski",
  "defaultMessages.locales.pt": "Português",
  "defaultMessages.locales.pt-BR": "Português (Brasil)",
  "defaultMessages.locales.ro": "Română",
  "defaultMessages.locales.ru": "Русский",
  "defaultMessages.locales.sk": "slovenský",
  "defaultMessages.locales.sl": "Slovenščina",
  "defaultMessages.locales.sr": "Српски",
  "defaultMessages.locales.sv": "Svenska",
  "defaultMessages.locales.sw": "Kiswahili",
  "defaultMessages.locales.th": "ไทย",
  "defaultMessages.locales.tr": "Türkçe",
  "defaultMessages.locales.uk": "Українська",
  "defaultMessages.locales.ur": "اردو",
  "defaultMessages.locales.vi": "Tiếng Việt",
  "defaultMessages.locales.zh": "中文（繁体）",
  "defaultMessages.locales.zh-HK": "中文（香港）",
  "defaultMessages.locales.zu": "IsiZulu",
  "defaultMessages.lowIncomeOrganization": "정부 지원 프로그램",
  "defaultMessages.lowIncomeOrganizationPlaceholder": "정부 지원 프로그램",
  "defaultMessages.lowRewardPool": "&#128293; 남은 혜택 {offersRemaining}개뿐!",
  "defaultMessages.memberId": "ID 번호",
  "defaultMessages.memberIdPlaceholder": "ID 번호",
  "defaultMessages.militaryFamilyCardNote": "참고: 이 혜택은 부양가족 ID 카드를 보유한 군인 가족에게만 제공됩니다.",
  "defaultMessages.militaryInfoShared": "여기에 입력된 정보는 본인 확인 목적으로 사용됩니다.",
  "defaultMessages.militaryStatus": "군인 신분",
  "defaultMessages.multipleLocationsTips": "학교에 여러 캠퍼스가 있고 귀하의 캠퍼스가 표시되지 않는 경우 본교를 입력하십시오.",
  "defaultMessages.noOptions": "옵션 없음",
  "defaultMessages.openMenu": "메뉴 열기",
  "defaultMessages.optIn": "예, {company}의 독점 세일, 특별 혜택, 최신 제품 등에 관한 마케팅 커뮤니케이션을 보내주세요",
  "defaultMessages.optional": "선택 사항",
  "defaultMessages.orgSearchSortAccessibilityLabel": "검색 결과 정렬",
  "defaultMessages.orgSearchSortByDistance": "거리순으로 정렬",
  "defaultMessages.orgSearchSortByRelevance": "관련성순으로 정렬",
  "defaultMessages.organization": "기관",
  "defaultMessages.organizationPlaceholder": "기관",
  "defaultMessages.personalInformation": "개인 정보",
  "defaultMessages.personalOrSchoolIsFine": "개인 이메일 또는 학교 이메일 모두 가능합니다",
  "defaultMessages.phoneNumber": "휴대폰 번호",
  "defaultMessages.phoneNumberExplanation": "선택 사항 - 상태 업데이트 문자 알림 받기",
  "defaultMessages.phoneNumberWarnMessage1": "휴대폰 번호를 입력하여 이 양식을 제출하면 확인 목적으로 SMS/문자 메시지 수신에 동의하는 것입니다. 이동통신사의 표준 문자 메시지(SMS) 및 데이터 요금이 적용될 수 있습니다.",
  "defaultMessages.phoneNumberWarnMessage2": "본인 확인 및 사기 방지를 위해서만 귀하의 이동통신 서비스 제공업체가 귀하의 휴대폰 번호 및 특정 계정 정보를 SheerID에 공개하도록 승인합니다.",
  "defaultMessages.phoneUsPlaceholder": "555-555-5555",
  "defaultMessages.postalCode": "우편번호",
  "defaultMessages.postalCodeExplanation": "면허 기관에 등록된 주소를 사용하세요",
  "defaultMessages.postalCodePlaceholder": "우편번호",
  "defaultMessages.poweredBy": "SheerID가 제공하는 본인 확인 서비스",
  "defaultMessages.privacyPolicy": "개인정보 처리방침",
  "defaultMessages.proceed": "진행",
  "defaultMessages.requestSchool": "학교가 보이지 않나요? 추가 요청을 해보세요.",
  "defaultMessages.requiredFields": "* 필수 정보",
  "defaultMessages.rewardCodeEmailNotification": "지금 또는 나중에 새 코드를 사용할 수 있도록 이메일로 사본을 보내드렸습니다. verify@sheerid.com에서 온 이메일을 확인하세요.",
  "defaultMessages.school": "학교",
  "defaultMessages.schoolName": "학교",
  "defaultMessages.schoolNamePlaceholder": "학교",
  "defaultMessages.sheeridFaqs": "SheerID 자주 묻는 질문",
  "defaultMessages.smsCodePlaceholder": "SMS 코드",
  "defaultMessages.ssn": "사회보장번호",
  "defaultMessages.ssnPlaceholder": "000-00-0000",
  "defaultMessages.state": "주",
  "defaultMessages.statePlaceholder": "주",
  "defaultMessages.states.AK": "알래스카",
  "defaultMessages.states.AL": "앨라배마",
  "defaultMessages.states.AR": "아칸소",
  "defaultMessages.states.AS": "아메리칸사모아",
  "defaultMessages.states.AZ": "애리조나",
  "defaultMessages.states.CA": "캘리포니아",
  "defaultMessages.states.CO": "콜로라도",
  "defaultMessages.states.CT": "코네티컷",
  "defaultMessages.states.DC": "컬럼비아 특별구",
  "defaultMessages.states.DE": "델라웨어",
  "defaultMessages.states.FL": "플로리다",
  "defaultMessages.states.GA": "조지아",
  "defaultMessages.states.GU": "괌",
  "defaultMessages.states.HI": "하와이",
  "defaultMessages.states.IA": "아이오와",
  "defaultMessages.states.ID": "아이다호",
  "defaultMessages.states.IL": "일리노이",
  "defaultMessages.states.IN": "인디애나",
  "defaultMessages.states.KS": "캔자스",
  "defaultMessages.states.KY": "켄터키",
  "defaultMessages.states.LA": "루이지애나",
  "defaultMessages.states.MA": "매사추세츠",
  "defaultMessages.states.MD": "메릴랜드",
  "defaultMessages.states.ME": "메인",
  "defaultMessages.states.MI": "미시간",
  "defaultMessages.states.MN": "미네소타",
  "defaultMessages.states.MO": "미주리",
  "defaultMessages.states.MS": "미시시피",
  "defaultMessages.states.MT": "몬태나",
  "defaultMessages.states.NC": "노스캐롤라이나",
  "defaultMessages.states.ND": "노스다코타",
  "defaultMessages.states.NE": "네브래스카",
  "defaultMessages.states.NH": "뉴햄프셔",
  "defaultMessages.states.NJ": "뉴저지",
  "defaultMessages.states.NM": "뉴멕시코",
  "defaultMessages.states.NV": "네바다",
  "defaultMessages.states.NY": "뉴욕",
  "defaultMessages.states.OH": "오하이오",
  "defaultMessages.states.OK": "오클라호마",
  "defaultMessages.states.OR": "오리건",
  "defaultMessages.states.PA": "펜실베이니아",
  "defaultMessages.states.PR": "푸에르토리코",
  "defaultMessages.states.RI": "로드아일랜드",
  "defaultMessages.states.SC": "사우스캐롤라이나",
  "defaultMessages.states.SD": "사우스다코타",
  "defaultMessages.states.TN": "테네시",
  "defaultMessages.states.TX": "텍사스",
  "defaultMessages.states.UT": "유타",
  "defaultMessages.states.VA": "버지니아",
  "defaultMessages.states.VI": "버진아일랜드",
  "defaultMessages.states.VT": "버몬트",
  "defaultMessages.states.WA": "워싱턴",
  "defaultMessages.states.WI": "위스콘신",
  "defaultMessages.states.WV": "웨스트버지니아",
  "defaultMessages.states.WY": "와이오밍",
  "defaultMessages.status": "상태",
  "defaultMessages.statusPlaceholder": "상태",
  "defaultMessages.step.collectIdentifier.inputExplanation": "인증 코드를 보내는 데 필요",
  "defaultMessages.step.collectIdentifier.submitButton": "계속",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdExplanation": "귀하의 전문 회원 등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdLabel": "등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerExplanation": "귀하의 전문 회원 등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerLabel": "등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberExplanation": "귀하의 전문 회원 등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberLabel": "글로벌 위치 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoExplanation": "귀하의 전문 회원 등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoLabel": "등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberExplanation": "귀하의 전문 회원 등록 번호",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberLabel": "등록 번호",
  "defaultMessages.step.collectPersonalInfo.submitButton": "내 {segment} 상태 확인",
  "defaultMessages.step.collectSocialSecurityNumber.selectOption": "옵션 선택",
  "defaultMessages.step.collectSocialSecurityNumber.title": "사회 보장 번호를 입력하세요",
  "defaultMessages.step.collectSocialSecurityNumber.uploadDoc": "문서 업로드",
  "defaultMessages.step.collectSocialSecurityNumber.uploadInstead": "대신 문서 업로드",
  "defaultMessages.step.collectSocialSecurityNumber.useSsn": "사회 보장 번호를 사용하여 확인",
  "defaultMessages.step.completeAuthentication.manuallyVerifyButton": "수동으로 확인",
  "defaultMessages.step.completeAuthentication.subtitle": "이메일로 전송된 코드를 입력하세요.",
  "defaultMessages.step.completeAuthentication.title": "로그인 상태 유지로 확인",
  "defaultMessages.step.consolation.subtitle": "안타깝게도 귀하의 상태를 확인할 수 없었지만, 귀하의 관심에 감사드리며 감사의 표시로 이 프로모션 코드를 제공합니다. 이 코드는 귀하에게만 고유하며 한 번만 사용할 수 있습니다.",
  "defaultMessages.step.consolation.title": "혜택 받기",
  "defaultMessages.step.consolation.verificationOnly": "이 제안에 관한 모든 질문은 {companyName}에 문의하시기 바랍니다.",
  "defaultMessages.step.docUpload.acceptableUploadExamples": "허용 가능한 예시:",
  "defaultMessages.step.docUpload.acceptableUploads.age.birthCertificate": "출생증명서",
  "defaultMessages.step.docUpload.acceptableUploads.age.driversLicense": "운전면허증",
  "defaultMessages.step.docUpload.acceptableUploads.age.passport": "여권",
  "defaultMessages.step.docUpload.acceptableUploads.age.stateId": "주 정부 발급 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdContent": "연방법에 따라 SheerID는 현역/예비역 군인 신분증 제출을 허용하지 않습니다.",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdTitle": "군인 신분증 사진을 업로드하지 마십시오.",
  "defaultMessages.step.docUpload.acceptableUploads.employment.employeeIdCard": "직원 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.employment.officialLetter": "공식 서한",
  "defaultMessages.step.docUpload.acceptableUploads.employment.payStub": "최근 90일 이내의 급여명세서",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.idCard": "신분증",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.letter": "공식 서한",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.payStub": "최근 60일 이내의 급여명세서",
  "defaultMessages.step.docUpload.acceptableUploads.licensedProfessional.license": "면허 증명서",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.program": "선택한 정부 지원 프로그램의 자격이 있음을 보여주는 카드의 앞면과 뒷면.",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalLetter": "선택한 정부 지원 프로그램의 정부 기관에서 발행한 승인서(예: 보충적 보장 소득(SSI) 자격 서류).",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalScreenshot": "선택한 정부 지원 프로그램의 온라인 포털 스크린샷으로 자격이 있음을 보여주는 것 (온라인 계정의 Medicaid 신청 상태 스크린샷).",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programBankStatement": "선택한 혜택의 최근 지급을 보여주는 은행 명세서.",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programCard": "선택한 정부 지원 프로그램의 자격이 있음을 보여주는 카드의 앞면과 뒷면 (예: SNAP 프로그램의 EBT 카드).",
  "defaultMessages.step.docUpload.acceptableUploads.medical.idCard": "ID 배지",
  "defaultMessages.step.docUpload.acceptableUploads.medical.letterEmployment": "최근 90일 이내 날짜가 기재된 회사 레터헤드의 재직 증명서",
  "defaultMessages.step.docUpload.acceptableUploads.medical.licenseCertificate": "의료 면허 또는 증명서",
  "defaultMessages.step.docUpload.acceptableUploads.medical.payStub": "최근 90일 이내의 급여명세서",
  "defaultMessages.step.docUpload.acceptableUploads.medical.photoPayStub": "사진 신분증 및 최근 급여명세서",
  "defaultMessages.step.docUpload.acceptableUploads.member.idCard": "회원 문서",
  "defaultMessages.step.docUpload.acceptableUploads.member.payStub": "최근 90일 이내의 급여명세서",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.leaveEarningStatement": "휴가 및 수입 명세서 (최근 90일 이내 날짜)",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.uniformedServicesId": "제복 복무 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.military.activeDuty": "현재 30일 이상 군대에서 현역으로 복무 중임을 증명하는 모든 문서",
  "defaultMessages.step.docUpload.acceptableUploads.military.dependent": "법적으로 제공이 허용된 문서로, 귀하가 등록된 군인 부양가족임을 증명하는 것.",
  "defaultMessages.step.docUpload.acceptableUploads.military.goldStarFamily": "신청자를 고인의 가족으로 나타내는 DD1300 양식/사상자 보고서",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.blueUniformedId": "퇴역 신분을 나타내는 제복 복무 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.dd214Form": "DD214 <em>(20년 이상 복무했거나 30% 이상의 장애 등급이 있는 경우)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.retireeId": "퇴역 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaDigitalId": "VA Digital ID <em>(20년 이상 복무했거나 30% 이상의 장애 등급이 있는 경우)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaHealthBenefitsCard": "VA 건강 혜택 서신 (30% 이상의 장애 등급이 있는 경우)",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.leaveEarningStatement": "휴가 및 수입 명세서 (최근 90일 이내 날짜)",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.uniformedServicesId": "제복 복무 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservistA": "현재 군대의 예비 구성 요소에서 복무 중임을 나타내는 모든 문서",
  "defaultMessages.step.docUpload.acceptableUploads.military.retiree": "군대에서 퇴역했음을 증명하는 모든 문서",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dd214Form": "DD214 양식",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.departmentVeteranId": "재향군인부 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dischargeCertificate": "제대 증명서",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.driverLicenseVeteran": "재향군인 지정이 있는 운전면허증",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaDigitalId": "VA 디지털 ID",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaHealthBenefitsCard": "VA 건강 혜택 카드",
  "defaultMessages.step.docUpload.acceptableUploads.military.veteran": "군 복무 자격을 갖추고 명예 제대를 증명하는 모든 문서",
  "defaultMessages.step.docUpload.acceptableUploads.officialLetter": "공식 서한",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.changeOfAddress": "미국 우편 서비스 주소 변경 확인 서류",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.mortgageDeed": "모기지 증서",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.rentalAgreement": "임대 계약",
  "defaultMessages.step.docUpload.acceptableUploads.senior.birthCertificate": "출생증명서",
  "defaultMessages.step.docUpload.acceptableUploads.senior.driversLicense": "운전면허증",
  "defaultMessages.step.docUpload.acceptableUploads.senior.passport": "여권",
  "defaultMessages.step.docUpload.acceptableUploads.senior.stateId": "주 정부 발급 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.student.classSchedule": "수업 시간표",
  "defaultMessages.step.docUpload.acceptableUploads.student.idCard": "만료일이 있는 학생 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.student.tuitionReceipt": "수업료 영수증",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.idCard": "교육자 신분증",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.payStub": "최근 90일 이내의 급여명세서",
  "defaultMessages.step.docUpload.acceptedTypes": "파일은 .jpg .jpeg .png .pdf 이어야 합니다",
  "defaultMessages.step.docUpload.addFile": "서류 추가",
  "defaultMessages.step.docUpload.allowedDocuments": "법적으로 제공이 허용된 서류만 업로드하세요.",
  "defaultMessages.step.docUpload.canIFinishLater": "나중에 완료할 수 있나요?",
  "defaultMessages.step.docUpload.canIFinishLaterDetails": "예, 지금 완료하지 않으면 제공하신 주소로 이 단계로 돌아오는 링크가 포함된 이메일을 자동으로 발송해 드립니다.",
  "defaultMessages.step.docUpload.confirm": "확인해 주세요.",
  "defaultMessages.step.docUpload.documentReviewProcess": "서류는 수동 및 자동 문서 검토의 최적 조합으로 진위 여부를 검토하고 제공하신 정보와 비교합니다.",
  "defaultMessages.step.docUpload.documentsMustInclude": "서류에는 다음이 포함되어야 합니다:",
  "defaultMessages.step.docUpload.nameChanged": "서류 발급 이후 이름이 변경된 경우, 공식 성명 변경을 보여주는 두 번째 서류를 업로드하세요.",
  "defaultMessages.step.docUpload.rejectedNextStep": "이를 수정하고 다시 시도해 주세요.",
  "defaultMessages.step.docUpload.rejectedSubtitle": "다음 이유로 귀하의 자격을 확인하지 못했습니다:",
  "defaultMessages.step.docUpload.rejectionReasons.CUSTOM_VALUE_OTHER": "제출된 서류에는 이 제안의 자격을 확인하기 위한 요건이 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_DATE_OTHER": "제출된 서류가 이 제안의 자격을 확인하기 위한 날짜 요건을 충족하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EMAIL_SCREENSHOT": "이메일 스크린샷은 수락할 수 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EXPIRED": "서류가 이미 만료되었거나 너무 오래 전에 발급되었습니다. 더 최근의 서류를 업로드하세요.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_HANDWRITTEN": "손으로 쓴 서류는 수락할 수 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_LIKELY_FRAUD": "이 제안의 자격을 확인하기에는 서류가 불충분합니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED": "제출하신 서류에 발급 날짜가 없거나 너무 오래 전에 발급되었습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED_FACULTY": "제출하신 서류는 현재 학년도의 재직을 증명하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_PASSWORD_PROTECTED": "비밀번호로 보호된 서류는 수락할 수 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_STATUS_OTHER": "제출된 서류에는 이 제안의 자격을 확인하기에 충분하지 않은 상태가 표시되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_TOO_FUTURE": "서류에 표시된 날짜가 미래에 너무 멀리 있습니다. 현재 상태를 증명하는 더 최근의 서류를 업로드하세요.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNREADABLE": "이미지 품질이 낮아 서류를 읽을 수 없었습니다. 밝고 선명하게 읽을 수 있는 이미지를 확보하고 다시 제출해 보세요.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNSUPPORTED": "서류가 공식적이지 않거나 허용되는 서류 유형 목록에 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_VALID_OTHER": "제출된 서류로는 이 제안의 자격을 확인할 수 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.EBT_CARD_NUMBER_OTHER": "제출된 EBT 카드로는 이 제안의 자격을 확인할 수 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_JOB_TITLE": "서류에 표시된 직함은 이 제안의 자격이 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_ORGANIZATION": "제출하신 서류에 있는 조직은 이 제안의 자격이 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "고등학생은 이 제안의 자격이 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_CUSTOM_VALUE": "서류에 이 제안에 대한 자격을 확인하는 데 필요한 정보가 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_DOCUMENT_DATE": "서류에 표시된 날짜는 현재 상태를 증명하기에 불충분합니다. 최근 월과 연도가 포함된 서류를 업로드하세요.",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_EBT_CARD_NUMBER": "업로드된 EBT 카드는 이 제안의 자격을 확인하기에 불충분합니다.",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_STATUS": "서류가 이 제안에 자격이 되는 상태임을 증명하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_BIRTHDATE": "서류의 생년월일이 인증 양식에 입력하신 생년월일과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_COMPANY_NAME_OR_ADDRESS": "서류의 회사명 또는 주소가 인증 양식에 입력하신 내용과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_CUSTOM_VALUE": "서류에 표시된 일부 정보가 인증 양식에 입력하신 내용과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_EBT_CARD_NUMBER": "업로드된 EBT 카드의 번호가 인증 양식에 입력된 번호와 다릅니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION": "제출하신 서류의 기관명이 인증 양식에 기재하신 기관과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_COUNTRY": "인증 양식에서 선택한 국가가 제출한 서류에 나타난 국가와 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_NAME": "인증 양식에 입력된 기관명이 제출한 서류에 나타난 기관명과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_FIRST_NAME": "서류의 이름이 인증 양식에 입력하신 이름과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_LAST_NAME": "인증 양식에 입력된 성이 제출한 서류에 나타난 이름과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_NAME": "제출하신 서류의 정보가 인증 양식에 제출된 이름 및/또는 성과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_STATUS": "서류의 상태가 인증 양식에 입력하신 상태와 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_CUSTOM_VALUE": "이 혜택에 대한 귀하의 자격을 입증하는 데 필요한 정보가 서류에 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_DOCUMENT_DATE": "현재 날짜가 누락되어 있습니다. 현재 상태를 증명하는 공식적이고 날짜가 있는 서류를 업로드하세요.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_EBT_CARD_NUMBER": "업로드된 EBT 카드에 카드 번호가 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION": "제출하신 서류에는 이 혜택의 자격을 결정하는 데 필요한 모든 정보가 포함되어 있지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "제출하신 서류에는 미국 군의 자격 있는 지부와의 소속이 표시되어 있지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_BIRTHDATE": "생년월일이 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_ORGANIZATION_NAME": "인증 양식에 입력된 기관명이 제출된 서류에 없습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_PERSON_NAME": "제출하신 서류에 이름 및/또는 성이 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "제출하신 서류는 현재 학기 등록을 증명하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_OR_MISMATCH_JOB_TITLE": "제출하신 서류의 직함이 누락되었거나 인증 양식에 입력하신 내용과 일치하지 않습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_FIRST_NAME": "제출된 서류에 귀하의 이름이 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_LAST_NAME": "제출된 서류에 귀하의 성이 누락되어 있습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.ORGANIZATION_NAME_OTHER": "제출한 서류에 표시된 기관명이 인증 양식에 제공된 것과 달랐습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.OTHER_CONTACT_US": "이 혜택에 대한 귀하의 자격을 확인하는 데 문제가 발생했습니다. 도움이 필요하시면 SheerID 고객 서비스에 문의하세요: customerservice@sheerid.com",
  "defaultMessages.step.docUpload.rejectionReasons.OUT_OF_RANGE_BIRTHDATE": "귀하의 생년월일이 이 혜택의 허용 범위를 벗어났습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.PAYSTUB_OUTDATED_LAST_30_DAYS": "최근 30일 이내에 발행된 급여 명세서를 업로드해 주세요.",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_BIRTHDATE_OTHER": "제출한 서류에 표시된 생년월일이 인증 양식에 제공된 것과 일치하지 않았습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIELD_MISMATCH": "제공된 서류의 필드가 인증 양식에 제공된 것과 일치하지 않았습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIRST_NAME_OTHER": "제출한 서류에 표시된 이름이 인증 양식에 제공된 것과 일치하지 않았습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_LAST_NAME_OTHER": "제출한 서류에 표시된 성이 인증 양식에 제공된 것과 일치하지 않았습니다.",
  "defaultMessages.step.docUpload.rejectionReasons.RESTRICTED_DOCUMENT": "법적 제한으로 인해 업로드된 정부 발급 신분증을 검토할 수 없었습니다.",
  "defaultMessages.step.docUpload.reviewTime": "예상 검토 시간은 {estimatedWaitTime}입니다.",
  "defaultMessages.step.docUpload.submitButtonLabel": "제출",
  "defaultMessages.step.docUpload.suggestedDocumentTypes": "권장 문서 유형",
  "defaultMessages.step.docUpload.title": "계속하려면 귀하의 상태를 확인하는 서류를 업로드하세요",
  "defaultMessages.step.docUpload.uploadInfo.affiliation": "해당 조직과의 <strong>현재 소속</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.birthDate": "<strong>생년월일</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.consentDE": "나는 연령 확인을 위해 내 신분증 사본의 처리 및 보관에 동의합니다. 이미지가 자동으로 사본으로 저장되며, 업로드 전에 일련번호를 지울 권리가 있음을 이해합니다.",
  "defaultMessages.step.docUpload.uploadInfo.dateCurrentYear": "현재 학년도 내의 <strong>날짜</strong> 또는 오늘 날짜로부터 90일 이내",
  "defaultMessages.step.docUpload.uploadInfo.employment.company": "<strong>귀하의 회사</strong>",
  "defaultMessages.step.docUpload.uploadInfo.employment.currentAffiliation": "해당 회사와의 <strong>현재 소속</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.currentAffiliation": "해당 조직과의 귀하의 현재 소속",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.emt.status": "해당 조직의 현재 <strong>EMT 상태</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.firefighter.status": "해당 조직의 현재 <strong>소방관 상태</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.license": "응급구조사로서의 귀하의 상태 또는 자격증",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.organization": "<strong>조직</strong> 이름",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.police.status": "해당 조직의 현재 <strong>경찰 상태</strong>",
  "defaultMessages.step.docUpload.uploadInfo.fullName": "이 양식에 입력한 귀하의 <strong>전체 이름</strong>",
  "defaultMessages.step.docUpload.uploadInfo.identity.validDate": "현재 유효한 날짜",
  "defaultMessages.step.docUpload.uploadInfo.institutionName": "전체 또는 약칭 <strong>학술 기관 이름</strong> 또는 로고",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.licenseStatus": "<strong>전문 면허 및/또는 인증 상태</strong>",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.validDate": "현재 <strong>유효한 날짜</strong>",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.ebtNumber": "EBT 카드 번호",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.fullName": "귀하의 전체 이름",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.validDate": "<strong>유효한 발급일</strong>（지난 12개월 이내）또는 만료일（유효해야 함）",
  "defaultMessages.step.docUpload.uploadInfo.medical.medicalRole": "귀하의 <strong>의료 전문가</strong> 역할",
  "defaultMessages.step.docUpload.uploadInfo.medical.status": "귀하의 의료 전문가 상태",
  "defaultMessages.step.docUpload.uploadInfo.medical.validDate": "현재 유효한 <strong>날짜</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.activeDuty.status": "현재 <strong>현역</strong> 상태",
  "defaultMessages.step.docUpload.uploadInfo.military.currentAffiliation": "군 복무와의 현재 소속 관계",
  "defaultMessages.step.docUpload.uploadInfo.military.dischargeDate": "귀하의 전역일（해당되는 경우）",
  "defaultMessages.step.docUpload.uploadInfo.military.goldStarFamily.status": "현재 <strong>군인 가족</strong> 상태",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryFamily.status": "현재 <strong>군인 가족</strong> 상태",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryRetiree.status": "<strong>퇴직자</strong> 상태",
  "defaultMessages.step.docUpload.uploadInfo.military.reservist.status": "현재 <strong>예비역</strong> 상태",
  "defaultMessages.step.docUpload.uploadInfo.military.serviceBranch": "<strong>복무 부대</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsDependent": "귀하의 이름, 성, 유효한 날짜 및 상태를 명확하게 보여주는 서류를 업로드하세요",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdContent": "법률에 따라 SheerID는 군인 신분증 사본을 처리할 수 없습니다.",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdTitle": "군인 신분증 사진을 업로드하지 마세요.",
  "defaultMessages.step.docUpload.uploadInfo.military.veteran.status": "<strong>재향군인</strong> 상태",
  "defaultMessages.step.docUpload.uploadInfo.organization": "<strong>조직 이름</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.address": "<strong>새 주소</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.validDate": "최근 이사를 위한 <strong>유효한 날짜</strong>",
  "defaultMessages.step.docUpload.uploadInfo.senior.birthDate": "<strong>생년월일</strong>",
  "defaultMessages.step.docUpload.uploadInfo.student.enrollmentDate": "현재 학기 등록을 증명하는 날짜（또는 지난 3개월 이내）",
  "defaultMessages.step.docUpload.uploadInfo.student.school": "귀하의 학교",
  "defaultMessages.step.docUpload.uploadInfo.teacher.currentSchoolYear": "현재 학년도의 날짜",
  "defaultMessages.step.docUpload.uploadInfo.teacher.school": "귀하의 학교",
  "defaultMessages.step.docUpload.whatHappensNext": "다음에 무슨 일이 일어나나요?",
  "defaultMessages.step.docUpload.whoIsSheerId": "서류 검토는 상태 확인을 전문으로 하는 신뢰할 수 있는 파트너인 SheerID가 처리합니다.",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.alternative": "업무용 이메일 주소에 접근할 수 없나요?",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.label": "업무용 이메일 주소",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.send": "이메일 전송",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.subtitle": "고용주가 제공한 이메일 주소를 입력하시면 인증 링크를 보내드리겠습니다",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.title": "업무용 이메일 주소를 사용하여 인증",
  "defaultMessages.step.emailLoop.errors.invalidEmail": "이 이메일 주소는 즉시 인증에 유효하지 않습니다. 고용주가 제공한 이메일 주소를 사용하거나 아래에 서류를 업로드하세요.",
  "defaultMessages.step.emailLoop.errors.resend": "이메일 전송 오류",
  "defaultMessages.step.emailLoop.resendButton": "재전송",
  "defaultMessages.step.emailLoop.skipEmail": "이 이메일을 받을 수 없나요? 클릭",
  "defaultMessages.step.emailLoop.skipEmail2": "계속하려면.",
  "defaultMessages.step.emailLoop.skipEmailCTA": "여기",
  "defaultMessages.step.emailLoop.subtitle2": "모든 세부 정보는 당사의 이메일 (verify@sheerid.com)을 확인하세요.",
  "defaultMessages.step.emailLoop.subtitleWithEmail": "인증 절차를 완료하기 위한 개인화된 링크가 포함된 이메일이 {email}로 발송되었습니다.",
  "defaultMessages.step.emailLoop.subtitleWithoutEmail": "인증 절차를 완료하기 위한 개인화된 링크가 포함된 이메일이 이메일 계정으로 발송되었습니다.",
  "defaultMessages.step.emailLoop.successResend": "이메일이 성공적으로 재전송되었습니다.",
  "defaultMessages.step.emailLoop.title": "이메일을 확인하세요",
  "defaultMessages.step.error.errorId.expiredProgram.buttonText": "더 많은 오퍼 보기",
  "defaultMessages.step.error.errorId.expiredProgram.title": "오퍼가 매진되었습니다!",
  "defaultMessages.step.error.errorId.inactiveProgram.buttonText": "더 많은 오퍼 보기",
  "defaultMessages.step.error.errorId.inactiveProgram.title": "오퍼가 매진되었습니다!",
  "defaultMessages.step.error.errorId.ineligibleOrganization.title": "귀하의 자격을 확인할 수 없었습니다.",
  "defaultMessages.step.error.errorId.missingRequiredExternalId.title": "로그인하세요.",
  "defaultMessages.step.error.errorId.missingRequiredMetadata.title": "로그인하세요.",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.buttonText": "더 많은 오퍼 보기",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.title": "오퍼가 매진되었습니다!",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.buttonText": "지원팀에 문의",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.title": "오퍼가 일시 중지되었습니다!",
  "defaultMessages.step.error.errorId.verificationLimitExceeded.title": "인증 한도 초과",
  "defaultMessages.step.error.title": "오류",
  "defaultMessages.step.idCheckLoop.continue": "계속",
  "defaultMessages.step.idCheckLoop.countrySelector.title": "발급 국가",
  "defaultMessages.step.idCheckLoop.disclaimer": "SheerID는 {companyName}의 신뢰할 수 있는 파트너로, 제3자 {serviceType}를 사용하여 신원 확인을 처리합니다.",
  "defaultMessages.step.idCheckLoop.docTypeSelector.subtitle": "카메라가 있는 휴대폰이나 웹캠이 있는 컴퓨터가 필요합니다.",
  "defaultMessages.step.idCheckLoop.docTypeSelector.title": "서류를 선택하세요",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.subtitle": "앞면과 뒷면",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.title": "운전면허증",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.subtitle": "앞면과 뒷면",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.title": "정부 발급 ID",
  "defaultMessages.step.idCheckLoop.docTypes.passport.subtitle": "사진 페이지",
  "defaultMessages.step.idCheckLoop.docTypes.passport.title": "여권",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.subtitle": "앞면과 뒷면",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.title": "거주 허가증",
  "defaultMessages.step.idCheckLoop.regula.addBackImage": "ID 뒷면 추가",
  "defaultMessages.step.idCheckLoop.regula.addFontImage": "ID 앞면 추가",
  "defaultMessages.step.idCheckLoop.regula.info.subtitle": "운전면허증, 주 신분증, 여권 또는 거주 허가증.",
  "defaultMessages.step.idCheckLoop.regula.info.title": "정부 발급 ID 사진",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityError": "이미지에 품질 문제가 있습니다. 이미지가 선명하고 잘 조명되어 있으며 모든 세부 정보가 보이는지 확인하세요.",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityErrorTitle": "서류를 처리할 수 없었습니다",
  "defaultMessages.step.idCheckLoop.regula.sdk.rejectedImageNextStep": "다시 촬영하여 업로드해 주세요.",
  "defaultMessages.step.idCheckLoop.regula.sdk.subtitle": "인증을 계속하려면 정부 발급 ID 사진을 제출하세요.",
  "defaultMessages.step.idCheckLoop.regula.sdk.title": "신분증 업로드",
  "defaultMessages.step.idCheckLoop.regula.sdk.uploadAgain": "다시 업로드",
  "defaultMessages.step.idCheckLoop.regula.submit": "제출",
  "defaultMessages.step.idCheckLoop.regula.terms": "「계속」을 클릭하면 {privacyPolicyLink} 및 {termsOfService}를 읽고 이해하고 동의한 것으로 간주됩니다.",
  "defaultMessages.step.idCheckLoop.regula.title": "계속하려면 신원을 확인해야 합니다.",
  "defaultMessages.step.idCheckLoop.regula.uploadFileError": "파일을 업로드하는 중 오류가 발생했습니다. 다시 시도해 주세요.",
  "defaultMessages.step.idCheckLoop.regula.uploadSubtitle": "문서의 정보가 쉽게 읽힐 수 있는지 확인하세요. 반사를 피하세요.",
  "defaultMessages.step.idCheckLoop.regula.uploadTitle": "정부 발급 ID 업로드",
  "defaultMessages.step.idCheckLoop.steps.docReview.title": "신분 증명서 업로드",
  "defaultMessages.step.idCheckLoop.steps.idCheck.subtitle": "운전면허증, 주 신분증, 여권 또는 거주 허가증과 같은 유효한 정부 발급 서류.",
  "defaultMessages.step.idCheckLoop.steps.idCheck.title": "정부 발급 ID 사진 찍기",
  "defaultMessages.step.idCheckLoop.steps.selfie.title": "셀카 찍기",
  "defaultMessages.step.idCheckLoop.subtitle": "카메라가 있는 휴대폰이나 웹캠이 있는 컴퓨터가 필요합니다.",
  "defaultMessages.step.idCheckLoop.terms": "「계속」을 클릭하면 {scanPolicy}, {privacyPolicyLink} 및 {termsOfService}를 읽고 이해하고 동의한 것으로 간주됩니다.",
  "defaultMessages.step.idCheckLoop.title": "신원을 확인하겠습니다",
  "defaultMessages.step.override.errors.codeOverrideLimit": "재정의 코드 한도를 초과했습니다.",
  "defaultMessages.step.override.errors.invalidCode": "유효하지 않은 재정의 코드입니다.",
  "defaultMessages.step.override.submitOverrideCodeButtonLabel": "재정의 코드 제출",
  "defaultMessages.step.override.subtitle": "매장에서 인증 중이며 자격을 증명할 서류가 없거나 서류 업로드에 어려움이 있는 경우, 매장 직원에게 문의하여 자격을 확인하세요.",
  "defaultMessages.step.override.subtitle2": "매장 직원은 귀하가 제안 자격이 있다고 판단할 경우 아래에 인증 재정의 코드를 입력할 수 있습니다.",
  "defaultMessages.step.override.title": "상태를 확인할 수 없습니다",
  "defaultMessages.step.override.verificationOverrideCodeLabel": "인증 재정의 코드",
  "defaultMessages.step.pending.idCheckLoop.subtitle": "잠시 기다려 주세요, 처리 시간은 일반적으로 몇 분 이내입니다.",
  "defaultMessages.step.pending.idCheckLoop.subtitle2": "검토가 완료되면 이메일을 보내드리겠습니다.",
  "defaultMessages.step.pending.idCheckLoop.title": "서류를 검토 중입니다",
  "defaultMessages.step.pending.subtitle": "SheerID가 귀하의 상태를 확인하기 위해 서류를 검토하고 있습니다. 이 과정은 최대 {maxReviewTime}이 소요될 수 있습니다.",
  "defaultMessages.step.pending.subtitle2": "여기서 기다리거나 결과를 알려드리겠습니다.",
  "defaultMessages.step.pending.subtitle3": "이메일로 연락드리겠습니다.",
  "defaultMessages.step.pending.titleReview": "검토 중",
  "defaultMessages.step.pending.turnaroundTime": "처리 시간은 일반적으로 {estReviewTime}이며, 드물게 높은 트래픽 시에는 최대 {maxReviewTime}이 소요될 수 있습니다.",
  "defaultMessages.step.personalInfo.captcha.error": "사람임을 확인할 수 없습니다. 연결을 확인하거나, 광고 차단기를 비활성화하거나, 페이지를 새로 고침하고 다시 시도해 주세요.",
  "defaultMessages.step.personalInfo.captcha.loading": "사람임을 확인 중입니다. 버튼이 활성화되면 \"{submitButtonText}\"를 다시 클릭해 주세요.",
  "defaultMessages.step.personalInfo.captcha.retryButton": "다시 시도",
  "defaultMessages.step.personalInfo.captcha.success": "확인이 완료되었습니다. 인증을 계속하려면 \"{submitButtonText}\"를 다시 클릭해 주세요.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.closing": "즐기세요!",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.message": "Verify@sheerid.com에서 확인된 제안 사용에 관한 세부 정보가 담긴 확인 이메일을 다시 보냈습니다.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.title": "전에 여기 오셨군요!",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.needChanges": "변경이 필요하신가요?",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.closing": "Verify@sheerid.com에서 다음 단계가 포함된 마지막 이메일을 다시 보냈습니다.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.message": "이 이메일은 진행 중인 인증과 연결되어 있습니다.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.title": "시작하신 것 같습니다.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.proceedHere": "여기서 계속",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.closing": "Verify@sheerid.com에서 다음 단계가 포함된 마지막 이메일을 다시 보냈습니다.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.message": "이 이메일은 진행 중인 인증과 연결되어 있으며 다른 서류를 업로드해야 합니다.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.title": "시작하신 것 같습니다.",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sendAgain": "다시 보내기",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sent": "전송됨!",
  "defaultMessages.step.personalInfo.submitButtonText": "인증하고 계속하기",
  "defaultMessages.step.personalInfo.verifyingSubtitle": "잠깐이면 충분합니다",
  "defaultMessages.step.personalInfo.verifyingTitle": "상태를 인증 중입니다",
  "defaultMessages.step.smsLoop.errors.codeExpired": "인증 코드를 확인할 수 없습니다.",
  "defaultMessages.step.smsLoop.errors.codeResendLimit": "최대 재시도 횟수에 도달했습니다.",
  "defaultMessages.step.smsLoop.errors.codeVerification": "인증 코드를 확인할 수 없습니다.",
  "defaultMessages.step.smsLoop.errors.resend": "SMS 메시지 전송 오류",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber1": "번호가 잘못되었나요? 클릭",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber2": "여기",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber3": "{companyName}으로 돌아가기",
  "defaultMessages.step.smsLoop.resendButton": "다시 보내기",
  "defaultMessages.step.smsLoop.submitButton": "제출",
  "defaultMessages.step.smsLoop.successResend": "SMS 메시지가 성공적으로 다시 전송되었습니다",
  "defaultMessages.step.smsLoop.titleWithNumber": "{number}(으)로 끝나는 휴대폰 번호로 SMS 메시지를 보냈습니다. 여기에 코드를 입력하세요.",
  "defaultMessages.step.smsLoop.titleWithoutNumber": "휴대폰 번호로 SMS를 보냈습니다. 여기에 코드를 입력해 주세요.",
  "defaultMessages.step.smsLoop.verificationCode": "인증 코드",
  "defaultMessages.step.sso.alternative": "자격 증명을 업로드하여 확인할 수도 있습니다",
  "defaultMessages.step.sso.cancel": "서류 업로드",
  "defaultMessages.step.sso.login": "내 학교에 로그인",
  "defaultMessages.step.sso.preheader": "가장 빠른 방법",
  "defaultMessages.step.sso.subtitle": "학교 웹 포털에 로그인하세요. 새 탭에서 열립니다.",
  "defaultMessages.step.sso.subtitle2": "로그인이 안 되나요?",
  "defaultMessages.step.sso.title": "학교 자격 증명을 사용하여 확인",
  "defaultMessages.step.success.copyCouponCode": "쿠폰 코드 복사",
  "defaultMessages.step.success.emailNotification": "사용 안내가 포함된 확인 이메일을 보내드렸습니다. {email}에서 온 이메일을 확인하세요.",
  "defaultMessages.step.success.rememberMe.consumerFound.button": "'나를 기억해'에 저장",
  "defaultMessages.step.success.rememberMe.consumerFound.description": "SheerID의 '나를 기억해' 서비스를 사용하여 {companyName} 및 다른 브랜드의 향후 혜택을 위한 새 정보를 저장하세요.",
  "defaultMessages.step.success.rememberMe.consumerFound.title": "프로필 업데이트",
  "defaultMessages.step.success.rememberMe.consumerNotFound.button": "지금 등록",
  "defaultMessages.step.success.rememberMe.consumerNotFound.description": "SheerID의 '나를 기억해' 서비스를 사용하여 {companyName} 및 다른 브랜드의 향후 혜택에 더 빠르게 접근하세요.",
  "defaultMessages.step.success.rememberMe.consumerNotFound.title": "1클릭 인증을 위해 정보 저장",
  "defaultMessages.step.success.verificationOnly": "SheerID는 인증만 처리합니다. 승인되셨으니, 프로모션 조건에 관한 모든 질문은 {companyName} 고객 서비스로 문의해 주세요.",
  "defaultMessages.step.thirdPartyLoop.error": "지원되지 않는 공급업체",
  "defaultMessages.step.thirdPartyLoop.signzy.cancel": "신분증 업로드",
  "defaultMessages.step.thirdPartyLoop.signzy.login": "DigiLocker에 로그인",
  "defaultMessages.step.thirdPartyLoop.signzy.subtitle": "DigiLocker 로그인 정보를 사용하여 확인",
  "defaultMessages.step.thirdPartyLoop.signzy.title": "DigiLocker를 사용하여 확인",
  "defaultMessages.streetAddress": "도로명 주소",
  "defaultMessages.studentInfoShared": "여기에 입력된 정보는 확인 목적으로 사용되며 {companyName}과 공유됩니다.",
  "defaultMessages.tryAgain": "다시 시도",
  "defaultMessages.tryFullNameTips": "약어나 두문자어 대신 학술 기관의 전체 이름을 입력해 보세요.",
  "defaultMessages.universityName": "대학교 이름",
  "defaultMessages.verificationPurposesOnly": "확인 목적으로만 사용",
  "defaultMessages.verifyAndContinue": "확인 후 계속",
  "defaultMessages.verifyMyEmploymentStatus": "내 직원 상태 확인",
  "defaultMessages.verifyMyFirstResponderStatus": "내 최초 대응자 상태 확인",
  "defaultMessages.verifyMyIdentityStatus": "내 신원 확인",
  "defaultMessages.verifyMyLicensedProfessionalStatus": "내 면허 전문가 상태 확인",
  "defaultMessages.verifyMyLowIncomeStatus": "내 상태 확인",
  "defaultMessages.verifyMyMedicalProfessionalStatus": "내 의료 전문가 상태 확인",
  "defaultMessages.verifyMyMembershipStatus": "내 회원 상태 확인",
  "defaultMessages.verifyMyMilitaryStatus": "내 군인 상태 확인",
  "defaultMessages.verifyMyMoverStatus": "내 신규 이사자 상태 확인",
  "defaultMessages.verifyMyStudentStatus": "내 학생 상태 확인",
  "defaultMessages.verifyMyTeacherStatus": "내 교육자 상태 확인",
  "defaultMessages.warningId.openOrganization": "데이터베이스에서 해당 이름과 일치하는 항목을 찾을 수 없습니다. 철자를 다시 확인해 주세요. 맞다면 계속 진행하세요!",
  "segmentMessages.age.emailExplanation": "개인 이메일 주소를 권장합니다",
  "segmentMessages.age.step.docUpload.title": "계속하려면 나이를 확인하는 서류를 업로드하세요",
  "segmentMessages.age.step.docUpload.uploadInstructions": "다음 내용을 보여주는 정부 발급 서류를 업로드하세요",
  "segmentMessages.age.step.docUpload.whoIsSheerId": "서류 검토는 연령 확인을 전문으로 하는 신뢰할 수 있는 파트너인 SheerID가 담당합니다.",
  "segmentMessages.age.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 특정 연령이어야 합니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하의 나이를 확인합니다. SheerID는 귀하의 자격을 확인하는 데 도움이 되는 정보만 수집합니다. 추가 정보나 서류가 요청될 수 있습니다.",
  "segmentMessages.age.step.personalInfo.submitButtonText": "확인 후 계속",
  "segmentMessages.age.step.personalInfo.subtitle": "현재 나이를 확인하세요.",
  "segmentMessages.age.step.personalInfo.title": "특별 혜택 잠금 해제",
  "segmentMessages.age.step.personalInfo.tryAgain.subtitle": "전체 이름과 생년월일은 정부 발급 서류에 기재된 정보와 일치해야 합니다.",
  "segmentMessages.age.step.personalInfo.tryAgain.title": "이름 및 생년월일 확인",
  "segmentMessages.age.step.personalInfo.verifyingTitle": "나이 확인 중",
  "segmentMessages.age.step.success.redirectButtonText": "계속",
  "segmentMessages.age.step.success.subtitle": "이제 이 특별 혜택을 받을 자격이 있습니다.",
  "segmentMessages.age.step.success.title": "확인이 완료되었습니다",
  "segmentMessages.employment.addressExplanation": "자택 주소를 사용하세요",
  "segmentMessages.employment.emailExplanation": "업무용 이메일이 있다면 사용하세요",
  "segmentMessages.employment.step.docUpload.title": "계속하려면 고용 상태를 확인하는 서류를 업로드하세요",
  "segmentMessages.employment.step.docUpload.uploadInstructions": "다음을 보여주는 공식 서류를 업로드하세요",
  "segmentMessages.employment.step.docUpload.whoIsSheerId": "서류 검토는 직원 확인을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.employment.step.personalInfo.howDoesVerifyingWorkDetails": "{{companyName}}은 선정된 기업의 모든 현직 직원을 위해 이 특별 혜택을 마련했습니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하가 현재 재직 중임을 확인합니다. SheerID는 귀하의 자격을 확인하는 데 도움이 되는 정보만 수집합니다. 추가 정보나 서류가 요청될 수 있습니다.",
  "segmentMessages.employment.step.personalInfo.submitButtonText": "직원 상태 확인",
  "segmentMessages.employment.step.personalInfo.subtitle": "자격 있는 회사의 현직 직원임을 확인하세요.",
  "segmentMessages.employment.step.personalInfo.title": "이 직원 전용 혜택 잠금 해제",
  "segmentMessages.employment.step.personalInfo.tryAgain.subtitle": "제공하신 정보는 공식 서류와 일치해야 합니다.",
  "segmentMessages.employment.step.personalInfo.tryAgain.title": "제공한 정보를 확인하세요",
  "segmentMessages.employment.step.personalInfo.verifyingTitle": "고용 상태 확인 중",
  "segmentMessages.employment.step.sso.alternative": "고용 증명서를 업로드하여 확인할 수도 있습니다",
  "segmentMessages.employment.step.sso.cancel": "고용 증명서 업로드",
  "segmentMessages.employment.step.sso.login": "내 이메일에 로그인",
  "segmentMessages.employment.step.sso.subtitle": "회사 이메일 포털에 로그인하세요. 새 탭에서 열립니다.",
  "segmentMessages.employment.step.sso.subtitle2": "이메일에 로그인할 수 없나요?",
  "segmentMessages.employment.step.sso.title": "회사 제공 이메일 자격증명으로 확인",
  "segmentMessages.employment.step.success.redirectButtonText": "계속",
  "segmentMessages.employment.step.success.subtitle": "이제 이 특별 혜택을 받을 자격이 있습니다.",
  "segmentMessages.employment.step.success.title": "확인이 완료되었습니다",
  "segmentMessages.firstResponder.emailExplanation": "업무용 이메일이 있다면 사용하세요",
  "segmentMessages.firstResponder.step.docUpload.title": "계속하려면 퍼스트 리스폰더 상태를 확인하는 서류를 업로드하세요",
  "segmentMessages.firstResponder.step.docUpload.uploadInstructions": "다음을 보여주는 공식 서류를 업로드하세요",
  "segmentMessages.firstResponder.step.docUpload.whoIsSheerId": "서류 검토는 퍼스트 리스폰더 확인을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.firstResponder.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택은 모든 미국 퍼스트 리스폰더 및 응급 요원(법 집행관, EMT, 구급대원, 소방관 포함)을 위해 제공됩니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하가 활동 중인 퍼스트 리스폰더임을 확인합니다. SheerID는 귀하의 자격을 확인하는 데 도움이 되는 정보만 수집합니다. 추가 정보나 서류가 요청될 수 있습니다.",
  "segmentMessages.firstResponder.step.personalInfo.submitButtonText": "퍼스트 리스폰더 상태 확인",
  "segmentMessages.firstResponder.step.personalInfo.subtitle": "활동 중인 퍼스트 리스폰더임을 확인하세요.",
  "segmentMessages.firstResponder.step.personalInfo.title": "이 퍼스트 리스폰더 전용 혜택 잠금 해제",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.subtitle": "전체 이름, 조직 이름, 이메일은 소속 기관의 기록과 일치해야 합니다.",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.title": "이름, 이메일 및 조직 확인",
  "segmentMessages.firstResponder.step.personalInfo.verifyingTitle": "퍼스트 리스폰더 상태 확인 중",
  "segmentMessages.firstResponder.step.success.redirectButtonText": "계속",
  "segmentMessages.firstResponder.step.success.subtitle": "이제 이 특별 혜택을 받을 자격이 있습니다.",
  "segmentMessages.firstResponder.step.success.title": "확인이 완료되었습니다",
  "segmentMessages.identity.emailExplanation": "개인 이메일 주소를 사용하는 것이 좋습니다",
  "segmentMessages.identity.step.docUpload.title": "계속하려면 귀하의 상태를 확인하는 서류를 업로드하세요",
  "segmentMessages.identity.step.docUpload.uploadInstructions": "다음을 보여주는 정부 발행 서류를 업로드하세요",
  "segmentMessages.identity.step.docUpload.whoIsSheerId": "문서 검토는 상태 인증을 전문으로 하는 신뢰할 수 있는 파트너인 SheerID가 처리합니다.",
  "segmentMessages.identity.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택의 자격을 갖추려면 유효한 운전면허증이 있어야 합니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하의 신원을 확인합니다. SheerID는 귀하의 자격을 확인하는 데 도움이 되는 정보만 수집합니다. 추가 정보나 서류를 요청할 수 있습니다.",
  "segmentMessages.identity.step.personalInfo.submitButtonText": "신원 확인하기",
  "segmentMessages.identity.step.personalInfo.subtitle": "현재 신원을 확인하세요.",
  "segmentMessages.identity.step.personalInfo.title": "나의 특별 혜택 잠금 해제",
  "segmentMessages.identity.step.personalInfo.tryAgain.subtitle": "입력한 정보는 정부 발행 서류와 일치해야 합니다.",
  "segmentMessages.identity.step.personalInfo.tryAgain.title": "이름 및 다른 항목을 확인하세요",
  "segmentMessages.identity.step.personalInfo.verifyingTitle": "신원을 확인하는 중입니다",
  "segmentMessages.identity.step.success.redirectButtonText": "계속",
  "segmentMessages.identity.step.success.subtitle": "이제 이 특별 혜택을 이용하실 수 있습니다.",
  "segmentMessages.identity.step.success.title": "인증되었습니다",
  "segmentMessages.licensedProfessional.emailExplanation": "업무용 이메일이 있으면 사용하세요",
  "segmentMessages.licensedProfessional.step.docUpload.title": "계속하려면 귀하가 면허 있는 전문가임을 확인하는 서류를 업로드하세요",
  "segmentMessages.licensedProfessional.step.docUpload.uploadInstructions": "다음을 보여주는 정부 발행 서류를 업로드하세요",
  "segmentMessages.licensedProfessional.step.docUpload.whoIsSheerId": "문서 검토는 면허 있는 전문가 인증을 전문으로 하는 신뢰할 수 있는 파트너인 SheerID가 처리합니다.",
  "segmentMessages.licensedProfessional.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택의 자격을 갖추려면 지정한 분야에서 현재 유효한 전문 자격증을 보유해야 합니다. 해당 분야는 이 양식의 상태 선택기에 표시됩니다.<br><br>{{companyName}}은 귀하가 면허 있는 전문가임을 확인하기 위해 신뢰할 수 있는 파트너인 SheerID를 사용합니다. SheerID는 귀하의 자격을 확인하는 데 도움이 되는 정보만 수집합니다. 추가 정보나 서류를 요청할 수 있습니다.",
  "segmentMessages.licensedProfessional.step.personalInfo.submitButtonText": "면허 있는 전문가 상태 확인하기",
  "segmentMessages.licensedProfessional.step.personalInfo.subtitle": "귀하의 분야에 전문 자격증이 있음을 확인하세요.",
  "segmentMessages.licensedProfessional.step.personalInfo.title": "이 특별 혜택을 잠금 해제하세요",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.subtitle": "입력한 정보는 정부 발행 서류와 일치해야 합니다.",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.title": "이름 및 다른 항목을 확인하세요",
  "segmentMessages.licensedProfessional.step.personalInfo.verifyingTitle": "자격증을 확인하는 중입니다",
  "segmentMessages.licensedProfessional.step.success.redirectButtonText": "계속",
  "segmentMessages.licensedProfessional.step.success.subtitle": "이제 이 특별 혜택을 이용하실 수 있습니다.",
  "segmentMessages.licensedProfessional.step.success.title": "인증되었습니다",
  "segmentMessages.lowIncome.addressExplanation": "집 주소를 사용하세요",
  "segmentMessages.lowIncome.step.docUpload.title": "계속하려면 승인된 정부 지원 프로그램 참여를 확인하는 서류를 업로드하세요",
  "segmentMessages.lowIncome.step.docUpload.uploadInstructions": "다음을 보여주는 공식 서류를 업로드하세요",
  "segmentMessages.lowIncome.step.docUpload.whoIsSheerId": "서류 검토는 자격 확인을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.lowIncome.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 현재 자격이 있는 정부 지원 프로그램의 요건을 충족해야 합니다. 이 혜택에 대한 자격 있는 정부 지원 프로그램은 아래 상자에서 확인할 수 있습니다.<br><br>{{companyName}}는 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하가 이러한 혜택의 수령자임을 확인합니다. SheerID는 자격 확인에 도움이 되는 정보만 수집합니다. 추가 정보 또는 서류가 요청될 수 있습니다.",
  "segmentMessages.lowIncome.step.personalInfo.submitButtonText": "내 상태 확인하기",
  "segmentMessages.lowIncome.step.personalInfo.subtitle": "자격이 있는 정부 지원 프로그램의 요건을 충족하는지 확인하세요.",
  "segmentMessages.lowIncome.step.personalInfo.title": "이 특별 혜택을 잠금 해제하세요",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.subtitle": "입력한 정보는 정부 발행 서류와 일치해야 합니다.",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.title": "전체 이름 및 다른 항목을 확인하세요",
  "segmentMessages.lowIncome.step.personalInfo.verifyingTitle": "상태를 확인하는 중입니다",
  "segmentMessages.lowIncome.step.success.redirectButtonText": "계속",
  "segmentMessages.lowIncome.step.success.subtitle": "이제 이 특별 혜택을 이용하실 수 있습니다.",
  "segmentMessages.lowIncome.step.success.title": "인증되었습니다",
  "segmentMessages.medical.emailExplanation": "업무용 이메일이 있으면 사용하세요",
  "segmentMessages.medical.step.docUpload.title": "계속하려면 의료 전문가로서의 신분을 확인하는 서류를 업로드하세요",
  "segmentMessages.medical.step.docUpload.uploadInstructions": "다음을 보여주는 공식 서류를 업로드하세요",
  "segmentMessages.medical.step.docUpload.whoIsSheerId": "서류 검토는 의료 전문가로서의 자격 확인을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.medical.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 면허를 보유하고 자격을 갖춘 의료 전문가여야 합니다. 여기에는 의사, 간호사, 약사 및 기타 의료 전문가가 포함됩니다.<br><br>{{companyName}}는 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하의 의료 전문가 신분을 확인합니다. SheerID는 자격 확인에 도움이 되는 정보만 수집합니다. 추가 정보 또는 서류가 요청될 수 있습니다.",
  "segmentMessages.medical.step.personalInfo.submitButtonText": "의료 전문가 신분 확인하기",
  "segmentMessages.medical.step.personalInfo.subtitle": "면허를 보유한 의료 전문가로서의 신분을 확인하세요.",
  "segmentMessages.medical.step.personalInfo.title": "의료 전문가를 위한 이 특별 혜택 이용하기",
  "segmentMessages.medical.step.personalInfo.tryAgain.subtitle": "귀하의 이름, 생년월일 및 기관이 당사 기록과 일치해야 합니다",
  "segmentMessages.medical.step.personalInfo.tryAgain.title": "이름, 생년월일 및 기관이 올바른지 확인하세요",
  "segmentMessages.medical.step.personalInfo.verifyingTitle": "의료 전문가 신분을 확인하는 중",
  "segmentMessages.medical.step.sso.alternative": "고용주 포털을 통해서도 확인할 수 있습니다",
  "segmentMessages.medical.step.sso.login": "고용주 포털에 로그인",
  "segmentMessages.medical.step.sso.subtitle": "조직의 자격 증명을 사용하여 상태를 확인하세요",
  "segmentMessages.medical.step.sso.title": "의료 종사자 신분 확인하기",
  "segmentMessages.medical.step.success.redirectButtonText": "계속",
  "segmentMessages.medical.step.success.subtitle": "이제 이 특별 혜택을 이용하실 수 있습니다.",
  "segmentMessages.medical.step.success.title": "인증되었습니다",
  "segmentMessages.member.step.docUpload.title": "계속하려면 자격이 있는 조직의 회원 자격을 확인하는 서류를 업로드하세요",
  "segmentMessages.member.step.docUpload.uploadInstructions": "다음을 보여주는 공식 서류를 업로드하세요",
  "segmentMessages.member.step.docUpload.whoIsSheerId": "서류 검토는 회원으로서의 자격 확인을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.member.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 자격이 있는 조직의 유효한 회원이어야 합니다. 이 혜택에 대한 자격 있는 조직은 아래 상자에서 확인할 수 있습니다.<br><br>{{companyName}}는 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하의 회원 자격을 확인합니다. SheerID는 자격 확인에 도움이 되는 정보만 수집합니다. 추가 정보 또는 서류가 요청될 수 있습니다.",
  "segmentMessages.member.step.personalInfo.submitButtonText": "회원 자격 상태 확인하기",
  "segmentMessages.member.step.personalInfo.subtitle": "자격이 있는 조직의 유효한 회원 자격을 확인하세요.",
  "segmentMessages.member.step.personalInfo.title": "회원을 위한 이 특별 혜택 이용하기",
  "segmentMessages.member.step.personalInfo.tryAgain.subtitle": "귀하의 정보는 조직의 공식 기록과 일치해야 합니다",
  "segmentMessages.member.step.personalInfo.tryAgain.title": "제공된 정보가 올바른지 확인하세요",
  "segmentMessages.member.step.personalInfo.verifyingTitle": "회원 자격을 확인하는 중",
  "segmentMessages.member.step.success.redirectButtonText": "계속",
  "segmentMessages.member.step.success.subtitle": "이제 이 특별 혜택을 이용하실 수 있습니다.",
  "segmentMessages.member.step.success.title": "인증되었습니다",
  "segmentMessages.military.emailExplanation": "개인 이메일 주소를 사용하는 것이 좋습니다",
  "segmentMessages.military.step.docUpload.title": "계속하려면 군인 신분을 확인하는 서류를 업로드하세요",
  "segmentMessages.military.step.docUpload.uploadInstructions": "다음을 보여주는 귀하의 정부 발행 서류를 업로드하세요",
  "segmentMessages.military.step.docUpload.whoIsSheerId": "서류 검토는 군인으로서의 자격 확인을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.military.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 현역, 예비역 또는 퇴역 군인이어야 합니다. 여기에는 현역 복무, 예비역, 退役 군인 및 그 가족이 포함됩니다.<br><br>{{companyName}}는 신뢰할 수 있는 파트너인 SheerID를 사용하여 귀하의 군인 신분을 확인합니다. SheerID는 자격 확인에 도움이 되는 정보만 수집합니다. 추가 정보 또는 서류가 요청될 수 있습니다.",
  "segmentMessages.military.step.personalInfo.submitButtonText": "군인 신분 확인하기",
  "segmentMessages.military.step.personalInfo.subtitle": "현역, 예비역 또는 퇴역 군인으로서의 신분을 확인하세요.",
  "segmentMessages.military.step.personalInfo.title": "군인을 위한 이 특별 혜택 이용하기",
  "segmentMessages.military.step.personalInfo.tryAgain.subtitle": "이름, 생년월일 및 군 지부가 올바른지 확인하세요",
  "segmentMessages.military.step.personalInfo.tryAgain.title": "이름과 생년월일을 확인하세요",
  "segmentMessages.military.step.personalInfo.verifyingTitle": "군인 신분을 확인하는 중",
  "segmentMessages.military.step.success.redirectButtonText": "계속",
  "segmentMessages.military.step.success.subtitle": "이제 이 특별 혜택을 이용하실 수 있습니다.",
  "segmentMessages.military.step.success.title": "인증되었습니다",
  "segmentMessages.recentMover.emailExplanation": "개인 이메일 주소를 권장합니다",
  "segmentMessages.recentMover.step.docUpload.title": "계속하려면 최근 이사를 확인하는 서류를 업로드하세요",
  "segmentMessages.recentMover.step.docUpload.uploadInstructions": "다음을 보여주는 공식 서류를 업로드하세요",
  "segmentMessages.recentMover.step.docUpload.whoIsSheerId": "서류 검토는 최근 이사한 사람들을 전문적으로 인증하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.recentMover.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 지난 60일 이내에 새 주소로 이사해야 합니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너 SheerID를 사용하여 귀하가 최근에 이사했음을 확인합니다. SheerID는 자격 확인에 필요한 정보만 수집합니다. 추가 정보 또는 서류를 요청할 수 있습니다.",
  "segmentMessages.recentMover.step.personalInfo.submitButtonText": "새로운 이사 상태 확인하기",
  "segmentMessages.recentMover.step.personalInfo.subtitle": "최근에 이사했음을 확인하세요.",
  "segmentMessages.recentMover.step.personalInfo.title": "이 특별 혜택 잠금 해제하기",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.subtitle": "성명과 주소는 공식 서류에 기재된 내용과 일치해야 합니다.",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.title": "이름 및 주소 정보 확인",
  "segmentMessages.recentMover.step.personalInfo.verifyingTitle": "이사 상태를 확인하는 중",
  "segmentMessages.recentMover.step.success.redirectButtonText": "계속",
  "segmentMessages.recentMover.step.success.subtitle": "이제 이 특별 혜택을 받으실 수 있습니다.",
  "segmentMessages.recentMover.step.success.title": "인증이 완료되었습니다",
  "segmentMessages.senior.emailExplanation": "개인 이메일 주소를 권장합니다",
  "segmentMessages.senior.step.docUpload.title": "계속하려면 나이를 확인하는 서류를 업로드하세요",
  "segmentMessages.senior.step.docUpload.uploadInstructions": "다음을 보여주는 정부 발급 서류를 업로드하세요",
  "segmentMessages.senior.step.docUpload.whoIsSheerId": "서류 검토는 나이 인증을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.senior.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 일정 나이 이상이어야 합니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너 SheerID를 사용하여 귀하의 나이를 확인합니다. SheerID는 자격 확인에 필요한 정보만 수집합니다. 추가 정보 또는 서류를 요청할 수 있습니다.",
  "segmentMessages.senior.step.personalInfo.submitButtonText": "확인하고 계속하기",
  "segmentMessages.senior.step.personalInfo.subtitle": "현재 나이를 확인하세요.",
  "segmentMessages.senior.step.personalInfo.title": "나의 특별 혜택 잠금 해제하기",
  "segmentMessages.senior.step.personalInfo.tryAgain.subtitle": "성명과 생년월일은 정부 발급 서류에 기재된 내용과 일치해야 합니다.",
  "segmentMessages.senior.step.personalInfo.tryAgain.title": "이름 및 생년월일 확인",
  "segmentMessages.senior.step.personalInfo.verifyingTitle": "나이를 확인하는 중",
  "segmentMessages.senior.step.success.redirectButtonText": "계속",
  "segmentMessages.senior.step.success.subtitle": "이제 이 특별 혜택을 받으실 수 있습니다.",
  "segmentMessages.senior.step.success.title": "인증이 완료되었습니다",
  "segmentMessages.student.emailExplanation": "학생 이메일 주소를 권장합니다",
  "segmentMessages.student.schoolName": "학교",
  "segmentMessages.student.step.docUpload.title": "계속하려면 학생 신분을 확인하는 서류를 업로드하세요",
  "segmentMessages.student.step.docUpload.uploadInstructions": "학교 발급 서류를 업로드하세요. 다음을 보여주는 것:",
  "segmentMessages.student.step.docUpload.whoIsSheerId": "서류 검토는 학생 인증을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.alternative": "학술 이메일 주소에 액세스할 수 없으신가요?",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.email.label": "학술 이메일 주소",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.subtitle": "학술 기관에서 제공한 이메일 주소를 입력하시면 인증 링크를 보내드립니다",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.title": "학술 이메일 주소로 확인하기",
  "segmentMessages.student.step.emailLoop.errors.invalidEmail": "이 이메일 주소는 즉시 인증에 유효하지 않습니다. 학술 기관에서 제공한 이메일 주소를 사용하거나 아래에 서류를 업로드하세요.",
  "segmentMessages.student.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 현재 학위 또는 자격증을 수여하는 인가된 교육 기관에 재학 중이어야 합니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너 SheerID를 사용하여 귀하가 현재 학생임을 확인합니다. SheerID는 자격 확인에 필요한 정보만 수집합니다. 추가 정보 또는 서류를 요청할 수 있습니다.",
  "segmentMessages.student.step.personalInfo.submitButtonText": "학생 상태 확인하기",
  "segmentMessages.student.step.personalInfo.subtitle": "학위 수여 학교의 학생임을 확인하세요.",
  "segmentMessages.student.step.personalInfo.title": "이 학생 전용 혜택 잠금 해제하기",
  "segmentMessages.student.step.personalInfo.tryAgain.subtitle": "성명과 생년월일은 공식 학교 기록에 기재된 내용과 일치해야 합니다.",
  "segmentMessages.student.step.personalInfo.tryAgain.title": "이름 및 생년월일 확인",
  "segmentMessages.student.step.personalInfo.verifyingTitle": "학생 상태를 확인하는 중",
  "segmentMessages.student.step.sso.alternative": "재학 증명서를 업로드하여 확인할 수도 있습니다",
  "segmentMessages.student.step.sso.cancel": "재학 증명서 업로드",
  "segmentMessages.student.step.sso.login": "학술 기관에 로그인하기",
  "segmentMessages.student.step.sso.subtitle": "학술 기관 포털이 새 창에서 열려 로그인 정보로 인증할 수 있습니다",
  "segmentMessages.student.step.sso.title": "학술 기관 자격 증명으로 확인하기",
  "segmentMessages.student.step.success.redirectButtonText": "계속",
  "segmentMessages.student.step.success.subtitle": "이제 이 특별 혜택을 받으실 수 있습니다.",
  "segmentMessages.student.step.success.title": "인증이 완료되었습니다",
  "segmentMessages.teacher.emailExplanation": "학교 발급 이메일 주소여야 합니다",
  "segmentMessages.teacher.schoolName": "학교 이름",
  "segmentMessages.teacher.schoolNamePlaceholder": "학교 이름",
  "segmentMessages.teacher.step.docUpload.title": "계속하려면 교육자 신분을 확인하는 서류를 업로드하세요",
  "segmentMessages.teacher.step.docUpload.uploadInstructions": "학교 발급 서류를 업로드하세요. 다음을 보여주는 것:",
  "segmentMessages.teacher.step.docUpload.whoIsSheerId": "서류 검토는 교육자 인증을 전문으로 하는 신뢰할 수 있는 파트너 SheerID가 처리합니다.",
  "segmentMessages.teacher.step.personalInfo.howDoesVerifyingWorkDetails": "이 혜택을 받으려면 현재 인가된 교육 기관에서 교육자, 교원 또는 직원으로 재직 중이어야 합니다.<br><br>{{companyName}}은 신뢰할 수 있는 파트너 SheerID를 사용하여 귀하가 현재 교육자, 교원 또는 직원임을 확인합니다. SheerID는 자격 확인에 필요한 정보만 수집합니다. 추가 정보 또는 서류를 요청할 수 있습니다.",
  "segmentMessages.teacher.step.personalInfo.submitButtonText": "교육자 상태 확인하기",
  "segmentMessages.teacher.step.personalInfo.subtitle": "인가된 교육 기관의 교육자, 교원 또는 직원임을 확인하세요.",
  "segmentMessages.teacher.step.personalInfo.title": "이 교육자 전용 혜택 잠금 해제하기",
  "segmentMessages.teacher.step.personalInfo.tryAgain.subtitle": "성명과 이메일 주소는 학교 기록에 등록된 내용과 일치해야 합니다.",
  "segmentMessages.teacher.step.personalInfo.tryAgain.title": "이름 및 이메일 확인",
  "segmentMessages.teacher.step.personalInfo.verifyingTitle": "교육자 상태를 확인하는 중",
  "segmentMessages.teacher.step.success.redirectButtonText": "계속",
  "segmentMessages.teacher.step.success.subtitle": "이제 이 특별 혜택을 받으실 수 있습니다.",
  "segmentMessages.teacher.step.success.title": "인증이 완료되었습니다",
  "defaultMessages.footerText_sso": "계속 진행함으로써, 귀하는 할인을 요청하는 사업체를 대신하여 처리자/제3자 서비스 제공업체 역할을 하는 SheerID와 귀하의 개인 정보를 공유하는 데 동의합니다. 귀하를 인증하기 위해 수집된 개인 정보는 귀하가 할인을 요청하는 사업체의 개인정보 보호 정책에 따라 처리될 것임을 인정합니다. <aboutSheerID>SheerID에 대해 더 알아보기.</aboutSheerID>",
  "defaultMessages.locales.tl": "Filipino",
  "defaultMessages.locales.kk": "Қазақ",
  "defaultMessages.locales.lv": "Latviešu",
  "defaultMessages.locales.et": "eesti",
  "defaultMessages.locales.ta": "தமிழ்",
  "defaultMessages.locales.fa": "فارسی"
}
